export default {
    secureStorageError: "Δεν ήταν δυνατή η αρχικοποίηση της ασφαλούς αποθήκευσης. Δοκιμάστε ξανά πριν συνδεθείτε.",
    secureStorageRetry: "Δοκιμάστε ξανά",
    // sign in/up
    email: "Email",
    username: "Όνομα Χρήστη",
    password: "Κωδικός",
    currPassword: "Τρέχων Κωδικός",
    newPassword: "Νέος Κωδικός",
    verifyNewPassword: "Επαλήθευση Νέου Κωδικού",
    changePassword: "Αλλαγή Κωδικού",
    signIn: "Σύνδεση",
    logout: "Αποσύνδεση",
    apiNotExists: "Το API δεν υπάρχει",
    noAnnouncements: "Δεν υπάρχουν ανακοινώσεις προς εμφάνιση.",

    // calendar
    clear: 'Εκκαθάριση',

    // home
    welcomeMorning: "Καλημέρα!",
    welcomeAfternoon: "Καλό απόγευμα!",
    welcomeEvening: "Καλησπέρα!",
    alLeft: "Υπόλοιπο",
    al: "Κανονική Άδεια",
    leaveUnit: "{{leaveUnit}}",

    // leaves
    leaveRecords: "Αρχείο Αδειών",
    noLeaveSelected: "Δεν Επιλέχθηκε Άδεια",
    noEmployeeSelected: "Δεν Επιλέχθηκε Υπάλληλος",
    plsSelectLeave: "Κάντε κλικ σε μια γραμμή για προβολή λεπτομερειών.",
    search: "Αναζήτηση",
    ls: "Κατάσταση",
    lAppr: "Εγκριτής/Εγκριτές",
    lAttach: "Συνημμένο/α",
    approverComments: "Σχόλια Εγκριτή",
    noLeaves: "Δεν υπάρχουν άδειες αυτή τη στιγμή - Ολόκληρη η Ομάδα Διαθέσιμη",
    weekLeaves: "Άδειες για την τρέχουσα εβδομάδα",
    weekLeavesSub: 'Μέλη ομάδας σε άδεια αυτή τη στιγμή',
    stimatedNote: "* Οι ημέρες είναι ενδεικτικές",

    // Reports
    showrep: "Εμφάνιση Αναφοράς",
    exportExcel: "Εξαγωγή σε Excel",
    refFilter: "Ανανέωση Φίλτρων",
    filter: "Φίλτρο",
    refFilterTool: "Πατήστε αυτό το κουμπί για να ανανεώσετε το φίλτρο με βάση την τρέχουσα επιλογή φίλτρου σας. Για παράδειγμα, εάν επιλέξατε εταιρεία, τα φίλτρα που σχετίζονται με την εταιρεία σας θα ανανεωθούν και όλες οι άλλες εταιρείες θα αποκρυφτούν",
    repGrps: "Ομάδες Αναφορών",
    reps: "Αναφορές",
    filters: "Φίλτρα Αναφοράς",
    mandatoryError: "Παρακαλώ επιλέξτε υποχρεωτικά φίλτρα: ",

    // STAFF LEVELS
    levelName: "Επίπεδο",
    order: "Σειρά",
    interfaceCode: "Κωδικός Διεπαφής",
    interfaceDescription: "Περιγραφή Διεπαφής",
    regionalCode: "Περιφερειακός Κωδικός",
    staffSuccessSave: "Επίπεδο Προσωπικού αποθηκεύτηκε με επιτυχία",
    staffSuccessDelete: "Επίπεδο Προσωπικού διαγράφηκε με επιτυχία",
    failedDelete: "Αποτυχία Διαγραφής",
    failedSave: "Αποτυχία Αποθήκευσης",
    invalidOrder: "Η σειρά πρέπει να είναι μόνο αριθμητική",
    noStaffDataPreview: "Δεν υπάρχουν διαθέσιμα δεδομένα\nΦαίνεται πως δεν έχουν προστεθεί ακόμη επίπεδα προσωπικού. Παρακαλώ προσθέστε νέο επίπεδο προσωπικού για να τα δείτε εδώ.",


    //SENIOTITY LEVELS
    HierarchyCode: "Κωδικός Ιεραρχίας",
    order: "Σειρά",
    person: "Άτομο",
    isOvertimePayable: "Πληρώνεται υπερωρία;",
    isOvertimeAllowed: "Επιτρέπονται υπερωρίες;",
    interfaceCode: "Κωδικός Διεπαφής",
    interfaceDescripiton: "Περιγραφή Διεπαφής",
    regionalCode: "Περιφερειακός Κωδικός",
    noSeniorityLevel: "Δεν υπάρχουν διαθέσιμα δεδομένα\nΦαίνεται πως δεν έχουν προστεθεί ακόμα Επίπεδα Ιεραρχίας. Παρακαλώ προσθέστε νέα Επίπεδα Ιεραρχίας για να τα δείτε εδώ.",
    requiredRegionalCode: " Παρακαλώ εισάγετε τον Περιφερειακό Κωδικό",
    requiredHierarchyCode: "Απαιτούμενος Κωδικός Ιεραρχίας",
    senioritySuccessSave: "Επίπεδο Ιεραρχίας αποθηκεύτηκε με επιτυχία",
    senioritySuccessDelete: "Επίπεδο Ιεραρχίας  διαγράφηκε με επιτυχία",
    cannotDeleteInUse: "Αδύνατη η διαγραφή, το επίπεδο αρχαιότητας είναι σε χρήση",
    invalidPerson: "Το πεδίο 'Άτομο' πρέπει να περιέχει μόνο αριθμούς",
    rowDeletedLocally: "Η εγγραφή διαγράφηκε τοπικά",
    invalidItem: "Μη έγκυρο αντικείμενο",
    duplicateHierarchyCodeMessage: "Duplicate hierarchy codes detected. Please check and correct duplicates.",


    // Company Job Titles
    jobTitleCode: "Κωδικός Τίτλου Εργασίας",

    abbreviation: "Συντομογραφία",
    regionalCode: "Περιφερειακός Κωδικός",
    alternativeDescription: "Εναλλακτική Περιγραφή",
    alternativeAbbreviation: "Εναλλακτική Συντομογραφία",
    d365Code: "Κωδικός D365",
    successSave: "Ο Τίτλος Εργασίας Αποθηκεύτηκε Επιτυχώς",
    successDelete: "Ο Τίτλος Εργασίας Διαγράφηκε Επιτυχώς",
    sortDesc: "Ταξινόμηση Κωδικού Τίτλου Α-Ω",
    sortAsc: "Ταξινόμηση Κωδικού Τίτλου Ω-Α",
    requiredJTC: "Ο Κωδικός Τίτλου Εργασίας είναι υποχρεωτικός.",
    Errorloadingjobtitles: "Σφάλμα φόρτωσης τίτλων εργασίας",

    // Leave Types Company
    code: "Κωδικός",
    cumulative: "Συσσωρευτικό με άλλο Τύπο Άδειας",
    showOnScheduler: "Εμφάνιση στο Πρόγραμμα",
    laRequired: "Απαιτείται Ανάλυση Άδειας",
    createLeaveScheme: "Δημιουργία Σχήματος Άδειας",
    ignoreLeaveSchemeRules: "Αγνόηση Κανόνων Σχήματος Άδειας",
    ignoreSaturdays: "Αγνόηση Σαββάτων στο Δικαίωμα Άδειας",
    ignoreSundays: "Αγνόηση Κυριακών στο Δικαίωμα Άδειας",
    ignorePublicHolidays: "Αγνόηση Αργιών στο Δικαίωμα Άδειας",
    ignoreWellbeingDays: "Αγνόηση Ημερών Ευεξίας στο Δικαίωμα Άδειας",
    canCF: "Ενεργοποίηση Μεταφοράς Υπολοίπου Άδειας",
    publicHoliday: "Αργία",
    wellbeingDay: "Ημέρα Ευεξίας",
    allowAttachment: "Επιτρέπεται Συνημμένο στην Άδεια",
    requireAttachment: "Το Συνημμένο είναι Υποχρεωτικό",
    allowNegativeBalance: "Επιτρέπεται Αρνητικό Υπόλοιπο",
    calendarDays: "Ημερολογιακές Ημέρες",
    setMonthsNotification: "Ορισμός Μηνών Ειδοποίησης",
    attachmentRequiredAfterUnits: "Απαιτείται συνημμένο όταν το δικαίωμα άδειας υπερβαίνει",
    customAllowance: "Προσαρμοσμένο Δικαίωμα",
    changeOfRule: "Αλλαγή Κανόνα",
    restrictWithinPeriod: "Περιορισμός εντός Περιόδου",
    cfExpiry: "Λήξη Μεταφοράς",
    balanceExceededMsg: "Μήνυμα Υπέρβασης Υπολοίπου",
    submittedMessage: "Μήνυμα Υποβολής",
    daysBefore: "Ημέρες Πριν",
    recreateLeavesForCurrentYear: 'Αναδημιουργία Αδειών για το Τρέχον Έτος',

    // Timesheets
    timesheet: 'Timesheet',
    timesheetName: 'Όνομα Φύλλου Χρόνου',
    approver: 'Εγκριτής',
    submitted: 'Υποβλήθηκε',
    year: 'Έτος',
    TSinfo: 'Πληροφορίες',
    newline: 'Νέο',
    showComments: 'Σχόλια',
    nameEmpty: 'Το όνομα του φύλλου χρόνου δεν μπορεί να είναι κενό',
    approverEmpty: 'Παρακαλώ επιλέξτε έναν εγκριτή',
    branchEmpty: 'Παρακαλώ επιλέξτε ένα υποκατάστημα',
    locationEmpty: 'Παρακαλώ επιλέξτε μια τοποθεσία',
    newEmpl: 'Νέος Υπάλληλος',
    addAll: 'Προσθήκη Όλων των Υπαλλήλων',
    missingptsdh: 'Παρακαλώ επιλέξτε χρονική περίοδο',
    defNum: 'Εισάγετε τον προεπιλεγμένο αριθμό περιόδων για να εφαρμοστεί σε όλους τους προστιθέμενους υπαλλήλους για όλους τους μήνες. Παρακαλώ σημειώστε ότι όλες οι τρέχουσες καταχωρήσεις θα διαγραφούν',
    average: 'Ετήσιος Μέσος Όρος',
    averageAdditional: 'Ετήσιος Πρόσθετος Μέσος Όρος',
    unitConvert: 'Converted Units',
    selectSchoolYearEndDate: 'Παρακαλώ επιλέξτε την ημερομηνία λήξης του σχολικού έτους για αυτόν τον υπάλληλο.',
    confirmSelection: 'Επιβεβαιώστε την επιλογή',
    pickAnItem: 'Επιλέξτε ένα αντικείμενο',
    tsErrorSaving: 'Η αποθήκευση του timesheet απέτυχε.',
    delete: 'Διαγραφη',
    saveAll: 'Aποθήκευση Timesheet',
    approvedSucess: 'Το timesheet έχει εγκριθεί.',
    rejectSuccess: 'Το timesheet έχει απορριφθεί.',
    errorSubmit: 'Υπήρξε σφάλμα κατά την υποβολή του timesheet.',
    rejCom: 'Σχόλια Απόρριψης',
    wayOfOvertime: "Επιλέξτε τρόπο πληρωμής υπερωριών",
    sum: 'Αθροισμα',
    total: "Σύνολο",
    standardUnits: "Τυπικές Μονάδες",
    overtime: "Υπερωρίες",
    payableOvertime: "Πληρωτέες Υπερωρίες",
    chargableU: "Χρεώσιμες Μονάδες",
    nonchargableU: "Μη Χρεώσιμες Μονάδες",
    payableOvertimeU: "Πληρωτέες Μονάδες Υπερωριών",
    expenseTotal: "Σύνολο Εξόδων (€)",
    viewTSDetails: "Προβολή Λεπτομερειών του timesheet",
    nopreviousTS: "Δεν υπάρχουν προηγούμενα timesheets",
    nopendingTS: "Δεν υπάρχουν εκκρεμή timesheets",
    pendingApprovalsTS: "Εκκρεμείς Εγκρίσεις",
    chargable: 'Χρεώσιμο',
    nonChargable: 'Μη Χρεώσιμο',
    errorReject: 'Αποτυχία απόρριψης. Παρουσιάστηκε σφάλμα κατά την απόρριψη του φύλλου εργασίας. Δοκιμάστε ξανά αργότερα',
    dateOutOfRange: 'Η επιλεγμένη ημερομηνία είναι εκτός της τρέχουσας περιόδου φύλλου χρόνου.',
    noEmployees: 'Δεν βρέθηκαν υπάλληλοι',
    succCreatingAll: 'Τα φύλλα χρόνου δημιουργήθηκαν επιτυχώς για όλους τους υπαλλήλους',
    errCreatingAll: 'Σφάλμα κατά τη δημιουργία των φύλλων χρόνου',
    noSubmit: 'Δεν υπάρχουν φύλλα χρόνου προς υποβολή',
    noAllSubmitSucc: 'Κάποια φύλλα χρόνου δεν υποβλήθηκαν επιτυχώς',
    TSleavesHolidays: 'Άδειες & Αργίες',
    exceedsMaxHours: "Υπέρβαση ωρών σε κάποιες ημέρες.",
    incompleteDays: "Ημέρες δεν έχουν συμπληρωθεί. Ελέγξτε και συμπληρώστε όλες τις ώρες.",
    etypenotFound: "Δεν βρέθηκε τύπος απασχόλησης",

    // Clients
    createNewClient: 'Δημιουργία Νέου Πελάτη',
    clientName: 'Όνομα Πελάτη',
    clientCode: 'Κωδικός Πελάτη',
    editClient: 'Επεξεργασία Πελάτη',
    update: 'Ενημέρωση',
    deleteClientConfirmation: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτόν τον πελάτη;',
    pleaseFillAllFields: 'Παρακαλώ συμπληρώστε όλα τα πεδία για να αποθηκεύσετε.',
    deleteSuccess: 'Ο πελάτης διαγράφηκε με επιτυχία',
    clientUpdatedSuccessfully: 'Ο πελάτης ενημερώθηκε με επιτυχία',
    clientCreatedSuccessfully: 'Ο πελάτης δημιουργήθηκε με επιτυχία',
    createNewProject: 'Δημιουργία Νέου Έργου',
    editProject: 'Επεξεργασία Έργου',
    noprojects: 'Δεν υπάρχουν έργα για αυτόν τον πελάτη.',
    partnerName: 'Όνομα Συνεργάτη',
    managerName: 'Όνομα Διαχειριστή',
    phasecode: 'Κωδικός Φάσης',
    isPayable: 'Πληρωτέο',
    projUpdatedSuccessfully: 'Το έργο ενημερώθηκε με επιτυχία',
    projectCreatedSuccessfully: 'Το έργο δημιουργήθηκε με επιτυχία',
    deleteProjectConfirmation: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το έργο;',
    codeMaxLengthWarning: 'Ο κωδικός πρέπει να έχει μέγιστο μήκος 7 χαρακτήρες.',
    formReset: 'Επαναφορά Φόρμας',
    deleteSuccessP: 'Το έργο διαγράφηκε επιτυχώς',
    descriptionRequired: "Η περιγραφή είναι υποχρεωτική.",
    jobNoRequired: "Ο αριθμός εργασίας είναι υποχρεωτικός.",
    phaseCodeRequired: "Ο κωδικός φάσης είναι υποχρεωτικός.",
    printTSSuccess: "Το timesheet εκτυπώθηκε με επιτυχία.",
    printTimesheet: "Εκτύπωση Timesheet",

    // Timesheet Expenses
    entity: 'Οντότητα',
    jobName: 'Όνομα Εργασίας',
    date: 'Ημερομηνία',
    expense: 'Έξοδο',
    unitRate: 'Τιμή Μονάδας',
    measureUnit: 'Μονάδα Μέτρησης',
    units: 'Μονάδες',
    attachmentsList: 'Λίστα Συνημμένων',
    noAttachments: 'Δεν έχουν ανέβει συνημμένα',
    uploadDocuments: 'Ανέβασμα Εγγράφων',
    doeRequired: "Η ημερομηνία δαπάνης είναι υποχρεωτική.",
    expCodeRequired: "Ο κωδικός δαπάνης είναι υποχρεωτικός.",

    //Copy Timesheet
    copyTSSuccess: "Το Timsheet αντιγράφηκε με επιτυχία.",
    errorcopy: "Υπήρξε σφάλμα κατά την αντιγραφή του timesheet.",
    copyTimesheet: "Αντιγραφή Timesheet",
    fromTimesheet: "Από Timesheet",
    toTimesheet: "Προς Timesheet",
    copy: "Αντιγραφή",
    deleteAllLinesBeforeCopy: "Πρέπει να διαγραφούν όλες οι υπάρχουσες γραμμές πριν την αντιγραφή του timesheet.",
    copyLines: "Αντιγραφή Γραμμών Timesheet",
    deleteTSMsg: "Διαγραφή timesheet και όλων των εγγεγραμμένων γραμμών του.",

    // Trainings
    loadTrainingsError: 'Παρουσιάστηκε σφάλμα κατά τη φόρτωση των δεδομένων.',
    noTrainings: 'Δεν υπάρχουν διαθέσιμα εκπαιδευτικά προγράμματα αυτή τη στιγμή.',
    titleAsc: 'Τίτλος Αύξουσα',
    titleDesc: 'Τίτλος Φθίνουσα',
    dateAsc: 'Ημερομηνία Αύξουσα',
    dateDesc: 'Ημερομηνία Φθίνουσα',
    all: 'Όλα',
    category: 'Κατηγορία',
    trainingLocation: 'Τοποθεσία Εκπαίδευσης',
    trainingProvider: 'Πάροχος Εκπαίδευσης',
    externalFacilitator: 'Εξωτερικός Διευκολυντής',
    ldNeed: 'Ανάγκη Μάθησης και Ανάπτυξης',
    ldMethod: 'Μέθοδος Μάθησης και Ανάπτυξης',
    isCompleted: 'Ολοκληρώθηκε',
    days: 'Ημέρες',
    hrs: 'Ώρες',
    workhrs: 'Ώρες Εργασίας',
    fees: 'Τέλη',
    subsidy: 'Επιχορήγηση',
    othercosts: 'Άλλα Έξοδα',
    costperempl: 'Μέσο Κόστος/Συμμετέχοντα',
    equalCost: 'Ίσο Κόστος/Συμμετέχοντα',
    isabroad: 'Εξωτερικό',
    isinternal: 'Εσωτερική Εκπαίδευση',
    iseLearning: 'Ηλεκτρονική Μάθηση',
    userEditable: 'Επεξεργάσιμο από Χρήστη',
    subsidyApplies: 'Ισχύει Επιχορήγηση',
    subsidyProvider: 'Πάροχος Επιχορήγησης',
    applicationDate: 'Ημερομηνία Αίτησης',
    receivedDate: 'Ημερομηνία Λήψης',
    doCertExp: 'Ημερομηνία Λήξης',
    certExpNotify: 'Ειδοποίησέ Με',
    comment: 'Σχόλιο',
    saveFailed: 'Αποτυχία αποθήκευσης δεδομένων εκπαίδευσης.',
    dateValidation: 'Η Ημερομηνία Λήξης πρέπει να είναι μετά την Ημερομηνία Έναρξης.',
    titleReq: 'Απαιτείται Τίτλος.',
    startDateReq: 'Απαιτείται Ημερομηνία Έναρξης.',
    endDateReq: 'Απαιτείται Ημερομηνία Λήξης.',
    companyReq: 'Απαιτείται Εταιρεία.',
    totalNumberOfParticipants: 'Συνολικός Αριθμός Συμμετεχόντων',
    participants: 'Συμμετέχοντες',
    isAccepted: 'Είναι Αποδεκτός',
    isFacilitator: 'Είναι Διευκολυντής',
    firstEvaluation: 'Πρώτη Αξιολόγηση',
    secondEvaluation: 'Δεύτερη Αξιολόγηση',
    cost: 'Κόστος',
    documentType: 'Τύπος Εγγράφου',
    fileName: 'Όνομα Αρχείου',

    // Modules
    duration: 'Διάρκεια (ώρες)',
    participantsLeft: 'Απομένουν Συμμετέχοντες',
    attendees: 'Συμμετέχοντες',
    facilitator: 'Διευκολυντές',
    employeeEmpty: 'Παρακαλώ επιλέξτε Υπάλληλο σε κάθε γραμμή',
    invalidDuration: 'Η διάρκεια δεν είναι έγκυρη.',
    descEmpty: 'Παρακαλώ συμπληρώστε το πεδίο Περιγραφή',
    NoDataPreview: 'Δεν υπάρχουν δεδομένα για προεπισκόπηση',
    training: 'Εκπαίδευση',
    trnEmpty: 'Δεν έχει επιλεγεί εκπαίδευση σε όλες τις γραμμές.',
    validationMssg: 'Μια εκπαίδευση έχει ήδη προαπαιτούμενα.',
    validationErr: 'Η επικύρωση των προαπαιτούμενων απέτυχε.',
    dublicatedTRN: 'Έχετε συμπεριλάβει την ίδια εκπαίδευση περισσότερες από μία φορές.',

    // Trainings
    loadTrainingsError: 'Παρουσιάστηκε σφάλμα κατά τη φόρτωση των δεδομένων.',
    noTrainings: 'Δεν υπάρχουν διαθέσιμα εκπαιδευτικά προγράμματα αυτή τη στιγμή.',
    titleAsc: 'Τίτλος Αύξουσα',
    titleDesc: 'Τίτλος Φθίνουσα',
    dateAsc: 'Ημερομηνία Αύξουσα',
    dateDesc: 'Ημερομηνία Φθίνουσα',
    all: 'Όλα',
    category: 'Κατηγορία',
    trainingLocation: 'Τοποθεσία Εκπαίδευσης',
    trainingProvider: 'Πάροχος Εκπαίδευσης',
    externalFacilitator: 'Εξωτερικός Διευκολυντής',
    ldNeed: 'Ανάγκη Μάθησης και Ανάπτυξης',
    ldMethod: 'Μέθοδος Μάθησης και Ανάπτυξης',
    isCompleted: 'Ολοκληρώθηκε',
    days: 'Ημέρες',
    hrs: 'Ώρες',
    workhrs: 'Ώρες Εργασίας',
    fees: 'Τέλη',
    subsidy: 'Επιχορήγηση',
    othercosts: 'Άλλα Έξοδα',
    costperempl: 'Μέσο Κόστος/Συμμετέχοντα',
    equalCost: 'Ίσο Κόστος/Συμμετέχοντα',
    isabroad: 'Εξωτερικό',
    isinternal: 'Εσωτερική Εκπαίδευση',
    iseLearning: 'Ηλεκτρονική Μάθηση',
    userEditable: 'Επεξεργάσιμο από Χρήστη',
    subsidyApplies: 'Ισχύει Επιχορήγηση',
    subsidyProvider: 'Πάροχος Επιχορήγησης',
    applicationDate: 'Ημερομηνία Αίτησης',
    receivedDate: 'Ημερομηνία Λήψης',
    doCertExp: 'Ημερομηνία Λήξης',
    certExpNotify: 'Ειδοποίησέ Με',
    comment: 'Σχόλιο',
    saveFailed: 'Αποτυχία αποθήκευσης δεδομένων εκπαίδευσης.',
    dateValidation: 'Η Ημερομηνία Λήξης πρέπει να είναι μετά την Ημερομηνία Έναρξης.',
    titleReq: 'Απαιτείται Τίτλος.',
    startDateReq: 'Απαιτείται Ημερομηνία Έναρξης.',
    endDateReq: 'Απαιτείται Ημερομηνία Λήξης.',
    companyReq: 'Απαιτείται Εταιρεία.',
    totalNumberOfParticipants: 'Συνολικός Αριθμός Συμμετεχόντων',
    participants: 'Συμμετέχοντες',
    isAccepted: 'Είναι Αποδεκτός',
    isFacilitator: 'Είναι Διευκολυντής',
    firstEvaluation: 'Πρώτη Αξιολόγηση',
    secondEvaluation: 'Δεύτερη Αξιολόγηση',
    cost: 'Κόστος',
    documentType: 'Τύπος Εγγράφου',
    fileName: 'Όνομα Αρχείου',
    deleteAllPartConfirmation: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε όλους τους συμμετέχοντες αυτής της εκπαίδευσης;',
    noFileAvailable: 'Δεν υπάρχει διαθέσιμο αρχείο για λήψη.',
    failedDownload: 'Αποτυχία προετοιμασίας αρχείου για λήψη.',
    dateTrnEmpty: 'Παρακαλώ επιλέξτε μια ημερομηνία.',
    typeEmpty: 'Παρακαλώ εισάγετε ένα έγγραφο ή τύπο εγγράφου.',
    noParticipantsToDelete: 'Δεν υπάρχουν συμμετέχοντες για διαγραφή.',
    allParticipantsDeleted: 'Όλοι οι συμμετέχοντες έχουν διαγραφεί.',
    errorDeletingParticipants: 'Σφάλμα κατά τη διαγραφή των συμμετεχόντων.',
    copyPartSuccess: 'Η αντιγραφή των συμμετεχόντων ολοκληρώθηκε με επιτυχία.',
    copyPartError: 'Παρουσιάστηκε σφάλμα κατά την αντιγραφή των συμμετεχόντων.',
    printTrnSuccess: 'Η αναφορά εκπαίδευσης εκτυπώθηκε με επιτυχία.',
    noParticipantsToExport: 'Δεν υπάρχουν συμμετέχοντες για εξαγωγή.',
    exportSuccess: 'Η εξαγωγή των συμμετεχόντων ολοκληρώθηκε με επιτυχία.',

    // Modules
    duration: 'Διάρκεια (ώρες)',
    participantsLeft: 'Απομένουν Συμμετέχοντες',
    attendees: 'Συμμετέχοντες',
    facilitator: 'Διευκολυντές',
    employeeEmpty: 'Παρακαλώ επιλέξτε Υπάλληλο σε κάθε γραμμή',
    invalidDuration: 'Η διάρκεια δεν είναι έγκυρη.',
    descEmpty: 'Παρακαλώ συμπληρώστε το πεδίο Περιγραφή',
    NoDataPreview: 'Δεν υπάρχουν δεδομένα για προεπισκόπηση',
    training: 'Εκπαίδευση',
    trnEmpty: 'Δεν έχει επιλεγεί εκπαίδευση σε όλες τις γραμμές.',
    validationMssg: 'Μια εκπαίδευση έχει ήδη προαπαιτούμενα.',
    validationErr: 'Η επικύρωση των προαπαιτούμενων απέτυχε.',
    dublicatedTRN: 'Έχετε συμπεριλάβει την ίδια εκπαίδευση περισσότερες από μία φορές.',

    //My Trainings
    filterAccepted: 'Φίλτρο Αποδοχής',
    dateOfCompletion: 'Ημερομηνία Ολοκλήρωσης',
    accepted: 'Αποδεκτό',
    pendingAcceptance: 'Εκκρεμεί Αποδοχή',
    courseName: 'Όνομα Μαθήματος',
    newTraining: 'Νέα Εκπαίδευση',
    TRNDetails: 'Λεπτομέρειες Εκπαίδευσης',
    durationHrs: 'Διάρκεια (Ώρες)',
    acknowledgeCompletion: 'Επιβεβαίωση Ολοκλήρωσης',
    errorInsert: 'Παρουσιάστηκε σφάλμα κατά την προσπάθεια εισαγωγής νέων δεδομένων.',
    confirmCompletion: 'Έχω διαβάσει και κατανοήσει το θέμα που παρουσιάζεται. Αφού πατήσετε Acceptance, παρακαλώ υπογράψτε το έντυπο συμμετοχής στην εκπαίδευση (στο τμήμα Ανθρώπινου Δυναμικού) και σημειώστε την ημερομηνία κατά την οποία ολοκληρώσατε την εκπαίδευση.',

    //Events
    event: 'Εκδήλωση',
    addOrg: 'Προσθήκη διοργανωτή',
    restrictRegistration: 'Περιορισμός εγγραφής',
    confirmParticipantsAutomatically: 'Αυτόματη επιβεβαίωση συμμετεχόντων',
    limitOnePersonPerParticipant: 'Περιορισμός σε μία συνεδρία ανά συμμετέχοντα',
    createEvent: 'Δημιουργία εκδήλωσης εκπαίδευσης',
    deleteAllPartBeforeEvent: 'Η δημιουργία της εκδήλωσης θα διαγράψει όλους τους συμμετέχοντες. Οι συμμετέχοντες στην εκδήλωση πρέπει να προστεθούν μέσω των συνεδριών της εκδήλωσης. Είστε βέβαιοι ότι θέλετε να προχωρήσετε;',
    cantAccessPartOnEventReason: 'Αυτή η εκπαίδευση έχει συνδεδεμένη εκδήλωση. Οι συμμετέχοντες στην εκδήλωση πρέπει να προστεθούν μέσω των συνεδριών της εκδήλωσης.',
    cantAccessPart: 'Δεν είναι δυνατή η προσθήκη συμμετεχόντων',
    errorSaving: 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση.',
    enterTitle: 'Εισάγετε τίτλο εκδήλωσης για να συνεχίσετε με την αποθήκευση.',
    enterDescription: 'Εισάγετε περιγραφή για να συνεχίσετε με την αποθήκευση.',
    enterAtLeastOneOrganizer: 'Εισάγετε τουλάχιστον έναν διοργανωτή για να συνεχίσετε με την αποθήκευση.',
    code: 'Κωδικός',
    codeEmpty: 'Παρακαλώ συμπληρώστε το πεδίο Κωδικός',
    cancelRegistretion: 'Ακύρωση Εγγραφής',
    session: 'Συνεδρία',
    register: 'Εγγραφή',
    registrationError: 'Παρουσιάστηκε σφάλμα κατά την προσπάθεια εγγραφής σας σε αυτό το event.',
    registrationSuccess: 'Η εγγραφή σας ήταν επιτυχής.',
    cancelRegistrationError: 'Παρουσιάστηκε σφάλμα κατά την προσπάθεια ακύρωσης της εγγραφής σας σε αυτό το event.',
    cancelRegistrationSuccess: 'Η ακύρωση της εγγραφής σας ήταν επιτυχής.',
    noEvents: 'Δεν υπάρχουν διαθέσιμες εκδηλώσεις.',
    noRegistrations: 'Δεν είστε εγγεγραμμένοι σε καμία εκδήλωση.',

    // new request
    teamOnLeave: "Μέλη ομάδας σε άδεια κατά την ίδια περίοδο:",
    TM: "* Άλλα μέλη της ομάδας είναι σε άδεια κατά την ίδια περίοδο",
    LT: "Τύπος Άδειας",
    LD: "Ημερομηνίες Άδειας",
    LDs: "Λεπτομέρειες Άδειας",
    LRDs: "Λεπτομέρειες Εγγραφής Άδειας",
    LL: "Γραμμές Άδειας",
    NOLAA: "Δεν υπάρχουν Εκκρεμείς Άδειες προς Έγκριση",
    selectDate: "Επιλογή Ημερομηνιών",
    selectDateTitle: "Επιλέξτε ημερομηνίες για τη διάρκεια της Αξιολόγησης",
    selectItem: "-- Επιλέξτε --",
    selectYear: "Επιλογή Έτους",
    Dur: "Διάρκεια",
    Rep: "Αντικατάσταση",
    Comm: "Σχόλια",
    anyComm: "Υπάρχουν σχόλια;",
    attach: "Συνημμένα",
    selectAttach: "Χωρίς Συνημμένα",
    open: "Άνοιγμα",
    remove: "Αφαίρεση",
    view: 'Προβολή',
    cancel: "Ακύρωση",
    okay: "Εντάξει",
    submit: "ΥΠΟΒΟΛΗ",
    edit: "Επεξεργασία",
    NLE: "Αίτηση Άδειας εκ μέρους",
    employee: "Υπάλληλος",

    // errors
    errDur0: "Η διάρκεια δεν μπορεί να είναι ίση με 0",
    errDur: "Μη έγκυρη Διάρκεια",
    errFile: "Το αρχείο είναι πολύ μεγάλο",
    errCalendar: "Παρακαλώ επιλέξτε ημερομηνία/ες",
    errApprover: "Υπάρχει σφάλμα με τους εγκριτές σας. Παρακαλώ επικοινωνήστε με τον Διαχειριστή HR για επίλυση. Η Άδεια έχει αποθηκευτεί, χρησιμοποιήστε το Οι Άδειές μου για υποβολή μόλις το σφάλμα επιλυθεί.",
    errReqFieldsNotFilled: "Παρακαλώ συμπληρώστε τα υποχρεωτικά πεδία που λείπουν και δοκιμάστε ξανά!",
    errNonUniqueValues: 'Υπάρχει άλλη εγγραφή με τις τρέχουσες τιμές. Ενημερώστε ανάλογα και δοκιμάστε ξανά.',

    // success
    succLA: "Η Αίτηση Άδειας υποβλήθηκε επιτυχώς",
    TEAM: "Η Ομάδα μου",
    succDocs: "Η Υποβολή Εγγράφου ήταν επιτυχής",

    // HR Admin
    teacherPeriods: 'Περίοδοι Εκπαιδευτικών',
    teacherPeriodsApproval: 'Εγκρίσεις',
    teacherPeriodsSucc: 'Οι Περίοδοι Εκπαιδευτικών αποθηκεύτηκαν επιτυχώς',
    teacherPeriodsfail: 'Αποτυχία αποθήκευσης Περιόδων Εκπαιδευτικών',

    emptyleave: 'Δεν υπάρχει Ανάλυση Άδειας.\nΠαρακαλώ επικοινωνήστε με τον Διαχειριστή HR',

    // LoadingLeaves
    LoadingLeaves: 'Ανανέωση Λίστας Αιτήσεων Άδειας',

    // upcoming
    thisWeek: "Αυτή την Εβδομάδα",
    startsOn: "Αρχίζει στις",
    noUpcoming: "Δεν υπάρχουν επερχόμενες άδειες αυτή την εβδομάδα",

    // Toggle
    toggleShow: 'Εμφάνιση Εγκεκριμένων',
    togglePending: 'Εμφάνιση Εκκρεμών',

    // balances
    available: "Διαθέσιμο",
    used: "Χρησιμοποιημένο",
    remaining: "Υπόλοιπο",
    show: "Εμφάνιση Λεπτομερειών",
    hide: "Απόκρυψη Λεπτομερειών",
    BroughtFoward: "Μεταφερθέν",
    BroughtFowardExpired: "Μεταφερθέν Ληγμένο",
    CurrAllowance: "Τρέχον Δικαίωμα",
    CurrAllowanceEOY: "Άδειες έως το τέλος του έτους",
    LeaveTaken: "Άδεια που Λήφθηκε",
    YearlyAllowance: "Ετήσιο Δικαίωμα",

    // team schedule
    noLeavesOnSelectedDate: "Δεν υπάρχουν άδειες στην επιλεγμένη ημερομηνία",
    selectDateRange: "Επιλογή Ημερομηνιών",

    // pending tasks
    pendingTasks: "Εκκρεμείς Εργασίες",
    pendingTasksSub: 'Ενέργειες που απαιτούνται από εσάς',
    noPending: "Δεν υπάρχουν εκκρεμείς εργασίες",

    oof: "ΕΚΤΟΣ ΓΡΑΦΕΙΟΥ",

    // personal information
    marital: "Οικογενειακή Κατάσταση",
    single: "Άγαμος/η",
    married: "Έγγαμος/η",
    engaged: "Αρραβωνιασμένος/η",
    divorced: "Διαζευγμένος/η",
    widow: "Χήρος/α",
    children: "Αρ. Τέκνων",
    address: "Διεύθυνση",
    town: "Πόλη",
    country: "Χώρα",
    postcode: "Ταχυδρομικός Κώδικας",
    postcodePlaceholder: "Ταχυδρομικός Κώδικας",
    personalMobile: "Προσωπικό Κινητό",
    personalEmail: "Προσωπικό Email",
    save: " ΑΠΟΘΗΚΕΥΣΗ ",
    noResultsFound: "Δεν βρέθηκαν αποτελέσματα",
    currentCity: 'Τρέχουσα Πόλη',
    currenctCountry: 'Τρέχουσα Χώρα',
    currentAddress: 'Τρέχουσα Διεύθυνση',

    // emergency information
    emergCont: "ΣΤΟΙΧΕΙΑ ΕΠΕΙΓΟΝΤΟΣ ΕΠΑΦΗΣ",
    relationship: "Σχέση",
    spouse: "Σύζυγος",
    father: "Πατέρας",
    mother: "Μητέρα",
    child: "Παιδί",
    other: "Άλλο",
    fullName: "Πλήρες Όνομα",
    telephone: "Τηλέφωνο",
    mobile: "Κινητό",
    emergDoc: "ΣΤΟΙΧΕΙΑ ΙΑΤΡΟΥ",
    emergContactDetails: 'Στοιχεία Επείγουσας Επαφής',

    // errors
    errTown: "Μη έγκυρη Πόλη",
    errCountry: "Μη έγκυρη Χώρα",
    errMobile: "Μη έγκυρος Αριθμός",
    errEmail: "Μη έγκυρο Email",
    errName: "Μη έγκυρο Όνομα",

    // documents
    noDocuments: "Δεν έχουν ανέβει έγγραφα ακόμα!",
    documentFunctionality: "Επεξεργασία / Διαγραφή",
    location: "Τοποθεσία",
    department: "Τμήμα",
    seniorityLevel: "Επίπεδο Αρχαιότητας",
    jobTitle: "Τίτλος Εργασίας",
    company: "Εταιρεία",
    chooseDocument: "Επιλογή Εγγράφου",
    downloadDocument: "Λήψη",
    chooseAllEmployees: "Επιλογή Όλων των Υπαλλήλων",
    findEmployees: "Εύρεση Υπαλλήλων",
    removeAllEmployees: "Αφαίρεση Όλων των Υπαλλήλων",
    chooseAnEmplMessage: "Παρακαλώ επιλέξτε τουλάχιστον έναν Υπάλληλο.",
    chooseACompanyMessage: "Παρακαλώ επιλέξτε πρώτα μια Εταιρεία.",
    chooseADocMessage: "Παρακαλώ επιλέξτε ένα Έγγραφο.",
    findEmplMessage: 'Παρακαλώ πατήστε πρώτα "Εύρεση Υπαλλήλων".',
    deleteDocMessage: 'Είστε σίγουροι ότι θέλετε να διαγράψετε το έγγραφο; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    yesButton: 'Ναι',
    noButton: 'Όχι',

    // LeaveSchemes
    Rules: 'Κανόνες',
    Parameters: 'Παράμετροι',
    Types: 'Τύποι Άδειας',
    params: 'Παράμετροι',
    leaveUnitNumber: 'Αριθμός Μονάδων Άδειας',
    workunits: 'Μονάδες Εργασίας/Εβδομάδα',
    boundary: 'Όριο',
    pro_rata: 'Αναλογικά',
    criteria: 'Κριτήρια',
    addcriteria: "Πρόσθετα Κριτήρια",
    appliedcriteria: "Εφαρμοσμένα Κριτήρια Φιλτραρίσματος",
    value: "Τιμή Παραμέτρου",
    shortleavemax: "Μέγιστο όριο σύντομης άδειας",
    shortleavetotal: "Σύνολο σύντομης άδειας",
    totalleavemax: "Μέγιστο συνολικό όριο άδειας",
    maxcf: "Μέγιστη Μεταφορά",
    twice: "Συμπεριλαμβάνεται Δύο Φορές",
    notIncluded: "Δεν Συμπεριλαμβάνεται",
    existingschemes: 'Σχήματα Άδειας για τον Επιλεγμένο Τύπο Άδειας',
    textdescr: 'Κριτήρια',

    // Mass Upload
    downloadAsExcel: 'Εξαγωγή σε Excel',
    viewExcel: 'Άνοιγμα Αρχείου Excel',
    importExcel: 'Μεταφόρτωση Αρχείου Excel',
    noDataFound: 'Δεν Υπάρχουν Διαθέσιμα Δεδομένα',
    incompatibleData: 'Τα παρεχόμενα δεδομένα δεν ταιριάζουν με τον επιλεγμένο προορισμό.\nΠαρακαλώ ενημερώστε είτε τον προορισμό είτε τα δεδομένα για να συνεχίσετε.',
    dataDestinationUpload: 'Επιλέξτε τον Προορισμό για τη Μεταφόρτωση Δεδομένων',
    succImportedExcel: 'Τα δεδομένα σας εισήχθησαν επιτυχώς!\n Ποσότητα Εισαγόμενων Δεδομένων',
    unsuccImportedExcel: 'Αντιμετωπίσαμε πρόβλημα κατά την εισαγωγή των δεδομένων σας. Παρακαλώ δοκιμάστε αργότερα. Εάν το πρόβλημα επιμένει, επικοινωνήστε με την ομάδα υποστήριξης.',
    unsavedChangesMassUploadMessage: 'Έχετε αποθηκεύτες αλλαγές.\n Αν επιστρέψετε τώρα, οι αλλαγές σας θα χαθούν.\n Παρακαλώ αποθηκεύστε τις αλλαγές σας πριν συνεχίσετε.',
    maxLength: 'Μέγιστο Μήκος',
    noMaxLength: 'Χωρίς Μέγιστο Μήκος',
    columnName: 'Όνομα Στήλης',
    dataType: 'Τύπος Δεδομένων',
    add: 'Προσθήκη',
    destinationTableMess: 'Έχετε επιλέξει τον σωστό πίνακα προορισμού για τα δεδομένα σας;\nΠαρακαλώ επαληθεύστε για να διασφαλίσετε ακριβή εισαγωγή δεδομένων.',
    hold: 'Μεταφόρτωση...\nΠαρακαλώ περιμένετε.',

    // custom phone number
    phoneNumber: "Αριθμός",

    // general responses/errors
    errRequired: "*Υποχρεωτικό",
    errSelectTypeBeforeDate: "Παρακαλώ επιλέξτε τύπο άδειας πριν επιλέξετε ημερομηνίες",
    errAllFields: "Παρακαλώ συμπληρώστε όλα τα υποχρεωτικά πεδία",
    detailsSaved: "Τα στοιχεία αποθηκεύτηκαν",
    errLoadingData: 'Παρουσιάστηκε σφάλμα κατά τη φόρτωση δεδομένων.',

    // password errors
    errMismatch: "Ο κωδικός και ο κωδικός επιβεβαίωσης δεν ταιριάζουν",

    // settings
    languageSelector: "Γλώσσα",

    // LAA
    approve: "ΕΓΚΡΙΣΗ",
    reject: "ΑΠΟΡΡΙΨΗ",
    TeamMembersOnLeave: "Επικαλυπτόμενες Εγκεκριμένες Άδειες",
    currentRemainder: "Τρέχον Υπόλοιπο",
    pendingApprovals: "Εκκρεμείς Εγκρίσεις Άδειας",

    leaveApprovalAccepted: "Η Έγκριση Άδειας Ολοκληρώθηκε Επιτυχώς",
    leaveApprovalRejected: "Η Απόρριψη Άδειας Ολοκληρώθηκε Επιτυχώς",
    leaveApprovalUnsubmitted: "Η Αναίρεση Υποβολής Άδειας Ολοκληρώθηκε Επιτυχώς",
    leaveApprovalAcceptedFailed: "Αποτυχία Έγκρισης Άδειας",
    leaveApprovalRejectedFailed: "Αποτυχία Απόρριψης Άδειας",
    leaveApprovalUnsubmittedFailed: "Αποτυχία Αναίρεσης Υποβολής Άδειας",

    asc: "ΑΠΟ ΠΑΛΑΙΟΤΕΡΟ ΣΕ ΝΕΟΤΕΡΟ",
    dsc: "ΑΠΟ ΝΕΟΤΕΡΟ ΣΕ ΠΑΛΑΙΟΤΕΡΟ",

    approved: "Εγκεκριμένη",
    approveAll: "Έγκριση Όλων",
    submitted: "Υποβλήθηκε Αναμένει Έγκριση",

    AllLeaves: "ΟΛΕΣ ΟΙ ΑΔΕΙΕΣ",
    SubmittedLeaves: "ΥΠΟΒΛΗΘΕΙΣΕΣ ΑΔΕΙΕΣ",
    ApprovedLeaves: "ΕΓΚΕΚΡΙΜΕΝΕΣ ΑΔΕΙΕΣ",
    UnsubmittedLeaves: "ΜΗ ΥΠΟΒΛΗΘΕΙΣΕΣ ΑΔΕΙΕΣ",
    RejectedLeaves: "ΑΠΟΡΡΙΦΘΕΙΣΕΣ ΑΔΕΙΕΣ",

    slLeft: "Υπόλοιπο Αναρρωτικής Άδειας",
    unsubmit: "Αναίρεση Υποβολής",

    true: "Αληθές",
    false: "Ψευδές",

    // Surveys
    survey: "Οι Έρευνές μου",
    surveyAdmin: "Διαχείριση Ερευνών",
    newAssm: "Νέα Αξιολόγηση",
    addQuestion: "Ερώτηση",
    addSection: "Ενότητα",
    requiredQuestion: "Υποχρεωτική Ερώτηση",
    questionTypeSelect: "Τύπος",
    importSurvey: "Εισαγωγή",
    saveSurvey: "Αποθήκευση",
    surveyResponse: "Απάντηση σε έρευνα",
    surveyEdit: "Επεξεργασία έρευνας",
    surveyResults: "Αποτελέσματα Έρευνας",
    updateSurvey: "Ενημέρωση",
    requireLogedInUser: "Απαιτείται Συνδεδεμένος Χρήστης",
    surveyname: "Όνομα",
    surveyinstructions: "Οδηγίες",
    surveyAdminFunction: "Λειτουργίες Διαχειριστή",
    surveycompletedon: "Ολοκληρώθηκε Στις",
    surveycomplete: "Ολοκληρώθηκε",
    resultsPerCandidate: "Όλα τα υποβληθέντα αποτελέσματα ερευνών",
    surveyAnalytics: "Αναλυτικά Ερευνών",
    analytics: "Αναλυτικά",
    Agree: "Συμφωνώ",
    stronglyAgree: "Συμφωνώ Απόλυτα",
    neutral: "Ουδέτερος/η",
    Disagree: "Διαφωνώ",
    stronglyDisagree: "Διαφωνώ Απόλυτα",
    allowedMultiple: "Επιτρέπεται Πολλαπλή Επιλογή",
    text: "Απαντήσεις Κειμένου",
    Rating5: "Αξιολόγηση 5 Αστέρων",
    Rating10: "Αξιολόγηση 10 Αστέρων",
    trueFalseOptions: "Επιλογές Αληθές / Ψευδές",
    ratingOptions: "Επιλογές Συμφωνώ / Διαφωνώ",
    options: "Επιλογές",
    surveyCreate: "Δημιουργία Έρευνας",
    addAgreeDisagreeOption: "Προσθήκη Υποερώτησης",

    // Assessments
    assessment: "Οι Αξιολογήσεις μου",
    assmEmplPreview: 'Προεπισκόπηση Αξιολόγησης Υπαλλήλου',
    assessmentsAdmin: "Διαχείριση Αξιολογήσεων",
    assessmentcomplete: "Ολοκληρωμένη",
    assessmentpending: "Εκκρεμής",
    AssessmentTitle: "Τίτλος Αξιολόγησης",
    sectiontitle: "Τίτλος Ενότητας",
    questionTitle: "Τίτλος Ερώτησης",
    assmTableOfContents: "Πίνακας Περιεχομένων",
    assmWeight: "Σύνολα Βαρών",
    assessmentclosed: "Κλειστή",
    assessmentname: "Όνομα",
    assessmenttype: "Τύπος",
    assessmentstatus: "Ποσοστό Ολοκλήρωσης Αξιολόγησης ανά Στάδιο",
    status: "Κατάσταση",
    assessmentsubmited: "Υποβλήθηκε",
    assessmentstage: "Στάδιο",
    assessmentsactive: "Ενεργή",
    assessmentedit: "Επεξεργασία Αξιολόγησης",
    assessmentdelete: "Διαγραφή",
    assessmentresult: "Αποτελέσματα Αξιολόγησης",
    assessmentResponse: "Απάντηση Αξιολόγησης",
    assessmentcreate: "Δημιουργία Αξιολόγησης",
    assmallowflag: "Επιτρέπεται Αλλαγή Αξιολογητή",
    assmselectworkflow: "Επιλογή Ροής Εργασίας",
    loadingselectedassm: "Φόρτωση Επιλεγμένης Αξιολόγησης...",
    assmselectcompany: "Επιλογή Εταιρείας",
    assmselectgroup: "Επιλογή Ομάδας",
    assmfunctionality: "Λειτουργίες Διαχειριστή",
    group: "Ομάδα",
    groupcreate: "Δημιουργία Ομάδας",
    grouptitle: "Τίτλος Ομάδας",
    lockgroup: "Κλείδωμα Ομάδας",
    groupedit: "Επεξεργασία Ομάδας",
    updategroup: "Ενημέρωση Ομάδας",
    quantitative: "Ποσοτικό",
    hidemeetingcomparison: "Απόκρυψη Σύγκρισης Συνάντησης",
    isSectionCover: 'Μετατροπή Ενότητας σε Εξώφυλλο',
    graphAxis: 'Άξονας Γραφήματος',
    useOnGraph: 'Χρήση στο Γράφημα Αποτελεσμάτων',
    isQuestCover: 'Μετατροπή Ερώτησης σε Εξώφυλλο',
    showresults: "Εμφάνιση στα Ενοποιημένα Αποτελέσματα",
    ROTW: "Μόνο Ανάγνωση για Ποιους",
    addQuestionLine: "Γραμμή",
    addTccQuestionLine: "Πρόσθετη Απάντηση",
    weight: "Βάρος (σε %)",
    totalSectionQuestions: "Όλα τα βάρη ερωτήσεων στην τρέχουσα ενότητα πρέπει να αθροίζουν 100%. Τρέχον σύνολο: ",
    totalSection: "Όλα τα βάρη ενοτήτων πρέπει να αθροίζουν 100%. Τρέχον σύνολο: ",
    weightMessage: "Σημειώστε ότι όλα τα βάρη πρέπει να αθροίζουν 100%",
    debug: "Εντοπισμός Σφαλμάτων",
    progress: "Πρόοδος",
    Essay: "Δοκίμιο",
    TableCustomControls: "Προσαρμοσμένοι Έλεγχοι Πίνακα",
    Scale: "Κλίμακα",
    ScaleNa: "Κλίμακα με Δ/Ι",
    Boxes: "Κουτιά Συμφωνώ/Διαφωνώ",
    requiredQuestionLine: "Υποχρεωτική Γραμμή Ερώτησης",
    required: "Υποχρεωτικό",
    cancelmessage: "Είστε σίγουροι ότι θέλετε να ακυρώσετε τη δημιουργία αυτής της Αξιολόγησης;",
    appraisee: "Αξιολογούμενος",
    sendReminder: "Υπενθυμίσεις",
    previewAppraisee: "Προεπισκόπηση Αξιολογούμενου",
    previewAppraiser: "Προεπισκόπηση Αξιολογητή",
    stage: "Στάδιο - ",
    appraiser: "Αξιολογητής",
    participations: "Συμμετοχές",
    appraiseename: "Όνομα Αξιολογούμενου",
    appraiseeid: "ID Αξιολογούμενου",
    appraisername: "Όνομα Αξιολογητή",
    appraiserid: "ID Αξιολογητή",
    allLeaves: "Όλες οι άδειες",
    allLeavesMinor: "Όλες οι Άδειες Φέτος",
    submittedMinor: "Αναμένει Έγκριση",
    approvedMinor: "Φέτος",
    rejected: "Απορρίφθηκε",
    rejectedMinor: "Φέτος",
    unsub: "Μη Υποβληθείσα",
    unsubMinor: "Πρόχειρο",
    activesubmitted: "Ενεργή / Υποβληθείσα",
    partfunctionality: "Λειτουργίες",
    showsubmitted: "Εμφάνιση Υποβληθεισών",
    showunsubmitted: "Εμφάνιση Μη Υποβληθεισών",
    goback: "Πίσω Τέλος",
    goforward: "Τέλος",
    partmessage: "Η τρέχουσα Αξιολόγηση θα αποθηκευτεί πριν προχωρήσετε.",
    updateassm: "Ενημέρωση",
    addparticipations: "Προσθήκη Συμμετέχοντα",
    editparticipations: "Επεξεργασία Συμμετέχοντα",
    deleteGroupConfirmation: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την Ομάδα;",
    deleteAssmConfirmation: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την Αξιολόγηση;",
    areusure: "Είστε σίγουροι;",
    cancelCreationMsg: "Η δημιουργία αυτής της αξιολόγησης θα ακυρωθεί",
    cancelEditMsg: "Οι αλλαγές σε αυτή την αξιολόγηση θα ακυρωθούν",
    importAssm: 'Εισαγωγή Αξιολόγησης',
    importPart: 'Εισαγωγή Συμμετεχόντων',
    addPart: "Προσθήκη Συμμετεχόντων",
    exportRawData: "Εξαγωγή Ακατέργαστων Δεδομένων",
    performanceReview: "Αξιολόγηση Απόδοσης",
    hideCompletionRate: "Απόκρυψη Ποσοστού Ολοκλήρωσης",
    hideExtraData: "Απόκρυψη Επιπλέον Δεδομένων",
    showCompletionRate: "Εμφάνιση Ποσοστού Ολοκλήρωσης",
    showExtraData: "Εμφάνιση Επιπλέον Δεδομένων",
    selectQuestionType: "-- Παρακαλώ επιλέξτε Τύπο Ερώτησης --",
    nothingToPreview: "Δεν υπάρχουν Αποτελέσματα για Προεπισκόπηση",
    noEmplAuth: "Δεν έχετε εξουσιοδότηση να δείτε κανέναν υπάλληλο. Παρακαλώ επικοινωνήστε με τον Διαχειριστή HR.",
    dragQuestion: "Παρακαλώ σύρετε την ερώτηση στη σωστή στήλη.",
    notSaved: "Δεν ήταν δυνατή η αποθήκευση της Αξιολόγησης. Παρακαλώ επικοινωνήστε με τον διαχειριστή σας",
    only1GraphSection: 'Πρέπει να ορίσετε δύο ενότητες για τη δημιουργία του Γραφήματος.',
    graphX: 'Παρακαλώ ορίστε μόνο 1 Άξονα Χ',
    graphY: 'Παρακαλώ ορίστε μόνο 1 Άξονα Υ',
    responsePlaceholder: 'Παρακαλώ εισάγετε την απάντησή σας',
    loadingMoreAssm: "Φόρτωση Περισσότερων Αξιολογήσεων...",
    saveGroupFailMsg: "Αποτυχία αποθήκευσης Ομάδας: ",
    saveAssmFailMsg: "Αποτυχία αποθήκευσης Αξιολόγησης!",
    weightTotalError: "Όλα τα βάρη πρέπει να αθροίζουν 100%",
    assmTitleError: "Παρακαλώ εισάγετε τίτλο Αξιολόγησης",
    assmDateError: "Παρακαλώ εισάγετε έγκυρες Ημερομηνίες Αξιολόγησης",
    assmWorkflowError: "Παρακαλώ εισάγετε Ροή Εργασίας Αξιολόγησης",
    assmCompanyError: "Παρακαλώ εισάγετε Εταιρεία Αξιολόγησης",
    assmGroupError: "Παρακαλώ εισάγετε Ομάδα Αξιολόγησης",
    assmQuestTitleError: "Παρακαλώ εισάγετε Τίτλους σε όλες τις Ερωτήσεις",
    assmQuestTypeError: "Παρακαλώ εισάγετε Τύπο Ερώτησης σε όλες τις Ερωτήσεις",
    assmQuestLineTypeError: "Παρακαλώ εισάγετε Τύπο Ερώτησης σε όλες τις Γραμμές Ερωτήσεων TCC",
    saveGroupErr: "Αποτυχία αποθήκευσης Ομάδας",
    questRequired: 'Παρακαλώ απαντήστε σε όλες τις Υποχρεωτικές Ερωτήσεις',

    // Company
    addCompanyLogo: 'Προσθήκη Λογοτύπου',
    loadingselectedCompany: 'Φόρτωση Επιλεγμένης Εταιρείας...',
    companyCode: 'Κωδικός Εταιρείας',
    companyLogo: 'Λογότυπο Εταιρείας',
    companyLogoSub: 'Ανεβάστε το λογότυπο ή την εικόνα branding της εταιρείας σας',
    companyName: 'Όνομα Εταιρείας',
    companyAnotherName: 'Εναλλακτικό Όνομα',
    companyLegalName: 'Νομική Επωνυμία',
    companyCurrency: 'Νόμισμα',
    companyActve: 'Ενεργή',
    compSaveSucc: 'Η Εταιρεία Αποθηκεύτηκε Επιτυχώς',
    compSaveFail: 'Αποτυχία Αποθήκευσης Εταιρείας',
    selectedCompany: 'Επιλεγμένη Εταιρεία',
    searchResults: 'Αποτελέσματα αναζήτησης για: ',
    selectCompany: 'Επιλέξτε εταιρεία πριν αναζητήσετε υπαλλήλους.',

    // Branches
    branch: "Υποκατάστημα",
    regCode: "Περιφερειακός Κώδικας",
    d365Code: "D365 Κωδικός",
    new: 'Νέο Υποκατάστημα',
    deleteBranch: 'Διαγραφή Υποκαταστήματος',
    saveChanges: 'Αποθήκευση Αλλαγών',
    changeBranchesMessage: 'Έχετε μη αποθηκευμένες αλλαγές. Εάν αλλάξετε κλάδο τώρα, οι αλλαγές σας θα χαθούν. Αποθηκεύστε τις αλλαγές σας πριν συνεχίσετε.',
    branchesLoadingPreview: 'Δεν υπάρχουν διαθέσιμα δεδομένα\nΦαίνεται ότι δεν έχουν προστεθεί ακόμη υποκαταστήματα. Παρακαλώ προσθέστε νέα υποκαταστήματα για να τα δείτε εδώ.',
    salarySchemeLoadingPreview: 'Φαίνεται ότι δεν έχουν προστεθεί ακόμη σχέδια μισθοδοσίας.\n Παρακαλώ προσθέστε νέα σχέδια μισθοδοσίας για να τα δείτε εδώ.',
    branches: 'Υποκαταστήματα',
    duplicates: 'Οι διπλές τιμές δεν επιτρέπονται. Παρακαλώ διορθώστε τις επισημασμένες τιμές',
    noChanges: 'Η αποθήκευση ακυρώθηκε, δεν υπάρχουν αλλαγές για αποθήκευση.',
    leaveCodeandDesc: 'Η αποθήκευση ακυρώθηκε, όλοι οι Κωδικοί Άδειας και οι Περιγραφές Άδειας πρέπει να είναι μοναδικοί',

    // Salary
    salarySchemeDesc: "Περιγραφή Σχήματος Μισθού",
    schemeRange: "Εύρος Ημερομηνιών Σχήματος Μισθού",
    salaryComponentDesc: "Περιγραφή Συνιστώσας Μισθού",
    order: "Σειρά",
    evaluation: "Αξιολόγηση",
    formula: "Τύπος",

    // Timesheets
    timesheet: 'Δελτίο Παρουσίας',
    timesheetName: 'Όνομα Δελτίου Παρουσίας',
    approver: 'Εγκριτής',
    year: 'Έτος',
    week: 'Εβδομάδα',
    newline: 'Νέο',
    showComments: 'Σχόλια',
    nameEmpty: 'Το όνομα του δελτίου παρουσίας δεν μπορεί να είναι κενό',
    approverEmpty: 'Παρακαλώ επιλέξτε εγκριτή',
    branchEmpty: 'Παρακαλώ επιλέξτε υποκατάστημα',
    locationEmpty: 'Παρακαλώ επιλέξτε Τοποθεσία',
    newEmpl: 'Νέος Υπάλληλος',
    addAll: 'Προσθήκη Όλων των Υπαλλήλων',
    missingptsdh: 'Παρακαλώ επιλέξτε περίοδο χρόνου',
    defNum: 'Εισάγετε τον προεπιλεγμένο αριθμό περιόδων για όλους τους υπαλλήλους για όλους τους μήνες. Σημειώστε ότι όλες οι τρέχουσες καταχωρίσεις θα διαγραφούν',
    average: 'Ετήσιος Μέσος Όρος',
    averageAdditional: 'Πρόσθετο',
    unitConvert: 'Μονάδες',
    addUnit: 'Πρόσθετες Μονάδες',
    selectSchoolYearEndDate: 'Παρακαλώ επιλέξτε ημερομηνία λήξης σχολικού έτους για αυτόν τον υπάλληλο.',
    confirmSelection: 'Επιβεβαίωση Επιλογής',
    pickAnItem: 'Επιλέξτε στοιχεία',
    oneItemSelected: 'Επιλέχθηκε Ένα Στοιχείο',
    tsErrorSaving: 'Αποτυχία αποθήκευσης δελτίου παρουσίας.',
    delete: 'Διαγραφή',
    saveAll: 'Αποθήκευση Δελτίου Παρουσίας',
    approvedSuccess: 'Το δελτίο παρουσίας εγκρίθηκε.',
    rejectSuccess: 'Το δελτίο παρουσίας απορρίφθηκε.',
    errorSubmit: 'Παρουσιάστηκε σφάλμα κατά την υποβολή του δελτίου παρουσίας.',
    rejCom: 'Σχόλια Απόρριψης',
    wayOfOvertime: "Επιλέξτε τρόπο πληρωμής υπερωριών",
    sum: 'ΣΥΝΟΛΟ',
    total: "Σύνολο",
    standardUnits: "Τυπικές Μονάδες",
    overtime: "Υπερωρία",
    payableOvertime: "Πληρωτέα Υπερωρία",
    chargableU: 'Χρεώσιμες Μονάδες',
    nonchargableU: 'Μη Χρεώσιμες Μονάδες',
    payableOvertimeU: 'Μονάδες Πληρωτέας Υπερωρίας',
    expenseTotal: 'Σύνολο Εξόδων (€)',
    viewTSDetails: "Προβολή Λεπτομερειών Δελτίου Παρουσίας",
    nopreviousTS: "Δεν υπάρχουν προηγούμενα δελτία παρουσίας",
    nopendingTS: "Δεν υπάρχουν εκκρεμή δελτία παρουσίας",
    pendingApprovalsTS: "Εκκρεμείς Εγκρίσεις",
    showperiodB: "Εμφάνιση Περιόδου Β",
    showperiodA: "Εμφάνιση Περιόδου Α",
    chargable: 'Χρεώσιμο',
    nonChargable: 'Μη Χρεώσιμο',
    dateOutOfRange: 'Η επιλεγμένη ημερομηνία είναι εκτός της τρέχουσας περιόδου δελτίου παρουσίας.',

    // Clients
    createNewClient: 'Δημιουργία Νέου Πελάτη',
    clientName: 'Όνομα Πελάτη',
    clientCode: 'Κωδικός Πελάτη',
    editClient: 'Επεξεργασία Πελάτη',
    update: 'Ενημέρωση',
    deleteClientConfirmation: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτόν τον Πελάτη;',
    pleaseFillAllFields: 'Παρακαλώ συμπληρώστε όλα τα πεδία για αποθήκευση.',
    deleteSuccess: 'Ο πελάτης διαγράφηκε επιτυχώς',
    clientUpdatedSuccessfully: 'Ο πελάτης ενημερώθηκε επιτυχώς',
    clientCreatedSuccessfully: 'Ο πελάτης δημιουργήθηκε επιτυχώς',
    createNewProject: 'Δημιουργία Νέου Έργου',
    editProject: 'Επεξεργασία Έργου',
    noprojects: 'Δεν υπάρχουν Έργα για αυτόν τον πελάτη.',
    partnerName: 'Όνομα Συνεργάτη',
    managerName: 'Όνομα Διευθυντή',
    phasecode: 'Κωδικός Φάσης',
    isPayable: 'Πληρωτέο',
    projUpdatedSuccessfully: 'Το έργο ενημερώθηκε επιτυχώς',
    projectCreatedSuccessfully: 'Το έργο δημιουργήθηκε επιτυχώς',
    deleteProjectConfirmation: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το Έργο;',
    codeMaxLengthWarning: 'Ο κωδικός πρέπει να έχει μέγιστο 7 χαρακτήρες.',
    formReset: 'Επαναφορά Φόρμας',
    deleteSuccessP: 'Το έργο διαγράφηκε επιτυχώς',
    insertError: 'Παρουσιάστηκε σφάλμα κατά την εισαγωγή. Παρακαλώ ελέγξτε ότι ο κωδικός είναι μοναδικός.',
    descriptionRequired: "Η Περιγραφή είναι υποχρεωτική.",
    jobNoRequired: "Ο Αριθμός Εργασίας είναι υποχρεωτικός",
    phaseCodeRequired: "Ο Κωδικός Φάσης είναι υποχρεωτικός",
    printTSSuccess: 'Το δελτίο παρουσίας εκτυπώθηκε επιτυχώς.',
    printTimesheet: 'Εκτύπωση Δελτίου Παρουσίας',

    // Timesheet Expenses
    entity: 'Οντότητα',
    jobName: 'Όνομα Εργασίας',
    date: 'Ημερομηνία',
    expense: 'Έξοδο',
    unitRate: 'Τιμή Μονάδας',
    measureUnit: 'Μονάδα Μέτρησης',
    units: 'Μονάδες',
    attachmentsList: 'Λίστα Συνημμένων',
    noAttachments: 'Δεν Έχουν Ανέβει Συνημμένα',
    uploadDocuments: 'Μεταφόρτωση Εγγράφων',
    doeRequired: "Η Ημερομηνία Εξόδου είναι υποχρεωτική.",
    expCodeRequired: "Ο Κωδικός Εξόδου είναι υποχρεωτικός",

    // Timescheme
    month: 'Μήνας',
    timescheme: 'Σχήμα Χρόνου',
    monday: 'Δευτέρα',
    tuesday: 'Τρίτη',
    wednesday: 'Τετάρτη',
    thursday: 'Πέμπτη',
    friday: 'Παρασκευή',
    saturday: 'Σάββατο',
    sunday: 'Κυριακή',
    hasEmptyTimeschemesError: 'Όλα τα Σχήματα Χρόνου πρέπει να συμπληρωθούν.',
    timeschemesSavedSuccMess: 'Τα Σχήματα Χρόνου αποθηκεύτηκαν επιτυχώς!',
    timeschemesErr: 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση των σχημάτων χρόνου. Παρακαλώ δοκιμάστε αργότερα.',

    // Copy Timesheet
    copyTSSuccess: 'Το δελτίο παρουσίας αντιγράφηκε επιτυχώς.',
    errorcopy: 'Παρουσιάστηκε σφάλμα κατά την αντιγραφή του δελτίου παρουσίας.',
    copyTimesheet: 'Αντιγραφή Δελτίου Παρουσίας',
    fromTimesheet: 'Από Δελτίο Παρουσίας',
    toTimesheet: 'Σε Δελτίο Παρουσίας',
    copy: 'Αντιγραφή',
    deleteAllLinesBeforeCopy: 'Απαιτείται διαγραφή όλων των υπαρχουσών γραμμών πριν την αντιγραφή δελτίου παρουσίας.',
    copyLines: 'Αντιγραφή Γραμμών Δελτίου Παρουσίας',
    deleteTSMsg: 'Διαγραφή δελτίου παρουσίας και όλων των καταχωρημένων γραμμών.',

    // Branches
    branch: "Υποκατάστημα",
    regCode: "Περιφερειακός Κωδικός",
    new: 'Νέο',
    deleteBranch: 'Διαγραφή',
    saveChanges: 'Αποθήκευση',

    // Documents
    nouserswerefound: 'Δεν Βρέθηκαν Χρήστες',

    // Employees
    loadingEmployees: 'Φόρτωση Υπαλλήλων...',
    reset: 'Επαναφορά',
    apply: 'Εφαρμογή',
    noSelectedCompanyPleaseSelect: 'Δεν έχει επιλεγεί εταιρεία. Παρακαλώ επιλέξτε εταιρεία από την καρτέλα Εταιρεία πρώτα!',
    changeBranchesMessage: 'Έχετε αναποθήκευτες αλλαγές.\n Αν αλλάξετε τώρα, οι αλλαγές σας θα χαθούν.\n Παρακαλώ αποθηκεύστε τις αλλαγές σας πριν συνεχίσετε.',
    branchesLoadingPreview: 'Δεν υπάρχουν διαθέσιμα δεδομένα\nΦαίνεται ότι δεν έχουν προστεθεί υποκαταστήματα ακόμα. Παρακαλώ προσθέστε νέα υποκαταστήματα για να τα δείτε εδώ.',
    branches: 'Υποκαταστήματα',
    salarySchemeLoadingPreview: 'Δεν υπάρχουν διαθέσιμα δεδομένα\nΦαίνεται ότι δεν έχουν προστεθεί Σχήματα Μισθού ακόμα. Παρακαλώ προσθέστε νέα Σχήματα Μισθού για να τα δείτε εδώ.',
    familyDetailsLoadingPreview: 'Δεν υπάρχουν διαθέσιμα δεδομένα\nΦαίνεται ότι δεν έχουν προστεθεί Οικογενειακές Λεπτομέρειες ακόμα. Παρακαλώ προσθέστε νέες Οικογενειακές Λεπτομέρειες για να τις δείτε εδώ.',
    promHistLoadingPreview: 'Δεν υπάρχουν διαθέσιμα δεδομένα\nΦαίνεται ότι δεν έχουν προστεθεί Λεπτομέρειες Ιστορικού Προαγωγών ακόμα. Παρακαλώ προσθέστε νέες Λεπτομέρειες Προαγωγής για να τις δείτε εδώ.',
    upload: 'Μεταφόρτωση Φωτογραφίας',

    // Salary
    startDate: "Ημερομηνία Έναρξης",
    endDate: "Ημερομηνία Λήξης",
    absenceType: "Τύπος Απουσίας",
    noAbsenceData: "Δεν υπάρχει Ανάλυση Απουσιών",
    noLeaveAnalysisData: "Δεν υπάρχουν Δεδομένα Ανάλυσης Άδειας",
    leaveBalance: "Υπόλοιπα Αδειών",
    NOFY: "Δεν βρέθηκαν οικονομικά έτη για τον επιλεγμένο υπάλληλο",

    // Edit Employee - Salary Reviews
    reviewDescription: "Περιγραφή Αναθεώρησης",
    schemeDescription: "Περιγραφή Σχήματος",
    comments: "Σχόλια",
    currency: "Νόμισμα",
    annualGrossSalary: "Ετήσιος Μεικτός Μισθός",
    monthlyGrossSalary: "Μηνιαίος Μεικτός Μισθός",
    changeSchemeMessage: "Αλλάζοντας το σχήμα μισθού, οι τιμές θα διαγραφούν γιατί έχει διαφορετικά συστατικά.",
    noReviewDataPreview: "Δεν υπάρχουν Διαθέσιμα Δεδομένα\nΦαίνεται ότι δεν έχουν προστεθεί Αναθεωρήσεις ακόμα. Παρακαλώ προσθέστε νέα Αναθεώρηση για να τη δείτε εδώ.",
    noShiftSchedules: "Δεν υπάρχουν διαθέσιμα δεδομένα\nΦαίνεται ότι δεν έχουν προστεθεί προγράμματα βαρδιών ακόμα. Παρακαλώ προσθέστε ένα νέο πρόγραμμα βαρδιών για να το δείτε εδώ.",
    salarySchemeMustBeSelected: "Πρέπει να Επιλεγεί Σχήμα Μισθού",
    reviewSavedSuccessfully: "Η Αναθεώρηση Αποθηκεύτηκε Επιτυχώς",
    errorSavingReview: "Σφάλμα Αποθήκευσης Αναθεώρησης",
    endDateMustBeSelected: "Πρέπει να Επιλεγεί Ημερομηνία Λήξης",
    reviewMarkedForDeletion: "Η Αναθεώρηση Επισημάνθηκε για Διαγραφή",
    nosalarycomponentsavailable: 'Δεν υπάρχουν Διαθέσιμες Συνιστώσες Μισθού',

    // Salary Modal
    enterComments: "Εισάγετε Σχόλια",
    editSalaryReview: "Συνιστώσα",
    salaryComponent: "Συνιστώσα Μισθού",
    current: "Τρέχουσα Αναθεώρηση",
    previous: "Προηγούμενη Αναθεώρηση",
    difference: "Διαφορά",
    percentageDifference: "Διαφορά (%)",

    // PERSONAL Tab
    personal: "Προσωπικά",
    personalDetails: "Προσωπικά Στοιχεία",
    name: 'Όνομα',
    firstName: 'Όνομα',
    lastName: 'Επώνυμο',
    sex: 'Φύλο',
    foreignEmplId: 'ID Αλλοδαπού Υπαλλήλου',
    telmob2: 'Δευτερεύον Κινητό Τηλέφωνο',
    hcode: 'Αρχαιότητα',
    holdate: 'Ημερομηνία Έναρξης Επαγγελματικής Εμπειρίας',
    isUnionM: 'Μέλος Συνδικάτου',
    parkLot: 'Θέση Στάθμευσης',
    parkingCardHolder: 'Κάτοχος κάρτας στάθμευσης;',
    car: 'Έχει Αυτοκίνητο;',
    nextOfKinOne: 'Πλησιέστερος Συγγενής:',
    nokAddressOne: 'Διεύθυνση Πλησιέστερου Συγγενή',
    nokTelMobOne: 'Κινητό Πλησιέστερου Συγγενή',
    nokTelOne: 'Τηλέφωνο Πλησιέστερου Συγγενή',
    nokRelOne: 'Σχέση Πλησιέστερου Συγγενή',
    emergencyContactDetails: 'Επείγουσα Επαφή',
    nextofkin: 'Όνομα:',
    nokaddress: 'Διεύθυνση',
    noktelmob: 'Αριθμός Τηλεφώνου',
    noktel: 'Τηλέφωνο Πλησιέστερου Συγγενή',
    nokRel: 'Σχέση',
    nameGR: 'Όνομα (άλλη γλώσσα)',
    drname: 'Όνομα Γιατρού',
    dradress: 'Διεύθυνση Γιατρού',
    drtel: 'Τηλέφωνο Γιατρού',
    drtelmob: 'Κινητό Γιατρού',
    companySecondary: 'Δευτερεύουσα Εταιρεία',
    locationSecondary: 'Δευτερεύουσα Τοποθεσία',
    title: 'Τίτλος',
    employeeID: 'ID',
    arcNumber: 'Αριθμός ARC',
    foreignId: 'Ξένο ID',
    telhome: 'Τηλέφωνο Κατοικίας',
    siNo: 'Αριθμός Κοινωνικών Ασφαλίσεων',
    taxID: 'ΑΦΜ',
    opmNameNickname: 'Ψευδώνυμο OPM',
    gender: 'Φύλο',
    initials: 'Αρχικά',
    nationality: 'Εθνικότητα',
    scndNationality: 'Δεύτερη Εθνικότητα',
    passportNo: 'Αριθμός Διαβατηρίου',
    passportIssDate: 'Ημερομηνία Έκδοσης Διαβατηρίου',
    passportExpDate: 'Ημερομηνία Λήξης Διαβατηρίου',
    dateOfBirth: 'Ημερομηνία Γέννησης',
    nameDay: 'Ονομαστική Εορτή',
    contactDetails: 'Στοιχεία Επικοινωνίας',
    area: 'Διεύθυνση Περιοχής',
    areacode: 'Κωδικός Περιοχής',
    bankAreaCode: 'Κωδικός Τραπεζικής Περιοχής',
    workMobile: 'Επαγγελματικό Κινητό',
    residenceTel: 'Τηλ. Κατοικίας',
    personalFax: 'Προσωπικό Φαξ',
    extLine1: 'Εσωτ. Γραμμή 1',
    extLine2: 'Εσωτ. Γραμμή 2',
    intercom: 'Εσωτερικό Τηλέφωνο',
    lockerNo: 'Αριθμός Ντουλαπιού',
    officeNo: 'Αριθμός Γραφείου',
    workEmail: 'Επαγγελματικό Email',
    homeAddress: 'Διεύθυνση Κατοικίας',
    homeCity: 'Πόλη Κατοικίας',
    homeCountry: 'Χώρα Κατοικίας',
    familyDetails: 'Οικογενειακά Στοιχεία',
    family: 'Οικογένεια',
    maritalStatus: 'Οικογενειακή Κατάσταση',
    noOfChildren: 'Αριθμός Τέκνων',
    ageGroup: 'Ηλικιακή Ομάδα',
    age: 'Ηλικία',
    nationalityGroup: 'Ομάδα Εθνικότητας',
    relType: 'Τύπος Σχέσης',
    relTypeReqMess: 'Ο Τύπος Σχέσης είναι υποχρεωτικός!',
    nameReqMess: 'Το Όνομα είναι υποχρεωτικό!',
    dotBeforeDoa: 'Η Ημερομηνία Λήξης πρέπει να είναι μεταγενέστερη της Ημερομηνίας Διορισμού!',
    doaReqMess: 'Η Ημερομηνία Διορισμού είναι υποχρεωτική!',
    deptReqMess: 'Το Τμήμα είναι υποχρεωτικό!',
    calcRevAllowanceMess: 'Υπολογισμός Αναθεωρημένου Δικαιώματος...',
    calcRevAllowanceSuccMess: 'Υπολογίστηκε το Αναθεωρημένο Δικαίωμα!',
    startDateBeforeEndDateMess: 'Η Ημερομηνία Έναρξης πρέπει να είναι ΠΡΙΝ την ημερομηνία λήξης!',
    noEndDateMess: 'Ο χρήστης δεν έχει ορισμένη ημερομηνία λήξης.',
    nameAlphabetOnlyMess: 'Το Όνομα μπορεί να περιέχει μόνο αλφαβητικούς χαρακτήρες!',
    occupation: 'Επάγγελμα',
    underSponsorship: 'Υπό Χορηγία',
    doNameday: 'Ονομαστική Εορτή',
    doIssuePassport: 'Ημερομηνία Έκδοσης Διαβατηρίου',
    familyDetailsTitle: 'Οικογενειακά Στοιχεία',
    telmob: 'Αριθμός Κινητού',
    educLevel: 'Επίπεδο Εκπαίδευσης',

    // EMPLOYMENT Tab
    employmentType: 'Τύπος Απασχόλησης',
    placementDetails: 'Λεπτομέρειες Τοποθέτησης',
    paymentDetails: 'Λεπτομέρειες Πληρωμής',
    employmentDetails: 'Λεπτομέρειες Απασχόλησης',
    employmentContext: 'Πλαίσιο Απασχόλησης',
    buildingFloor: 'Όροφος',
    l4: 'L4',
    l5: 'L5',
    l6: 'L6',
    seniority: 'Αρχαιότητα',
    paymentLevel: 'Επίπεδο Μισθοδοσίας',
    paymentSubLevel: 'Υποεπίπεδο Μισθοδοσίας',
    jobDescription: 'Περιγραφή Θέσης',
    specialDuties: 'Ειδικά Καθήκοντα',
    salaryEligibility: 'Δικαίωμα 13ου Μισθού',
    ministryOfEdu: 'Υπουργείο Παιδείας',
    subject: 'Αντικείμενο',
    staffLevel: 'Επίπεδο Προσωπικού',
    jobTitles: 'Τίτλοι Εργασίας',
    bank: 'Τράπεζα',
    accountNo: 'Αριθμός Λογαριασμού',
    annualGrossSalaryGroup: 'Ομάδα Ετήσιου Μεικτού Μισθού',
    paymentMethod: 'Τρόπος Πληρωμής',
    salarySpecifics: 'Λεπτομέρειες Μισθού',
    actualStartDate: 'Πραγματική Ημερομηνία Έναρξης',
    profExperienceStartDate: 'Ημερομηνία Έναρξης Επαγγελματικής Εμπειρίας',
    expectedRetirementDate: 'Αναμενόμενη Ημερομηνία Συνταξιοδότησης',
    dateMadePermanent: 'Ημερομηνία Μονιμοποίησης',
    probationPeriodMonths: 'Δοκιμαστική Περίοδος σε Μήνες',
    initialDeloitteStartDate: 'Ημερομηνία Λήξης Τρέχοντος Συμβολαίου',
    transferDate: 'Ημερομηνία Μετακίνησης',
    active: 'Ενεργός',
    resigned: 'Παραιτήθηκε',
    notonprobation: 'Μόνιμος',
    submitsTimesheets: 'Υποβάλλει Δελτία Παρουσίας',
    hasSignedConfLetter: 'Έχει Υπογράψει Επιστολή Εμπιστευτικότητας',
    employeeNumber: 'Αριθμός Υπαλλήλου',
    timeCardNo: 'Αριθμός Κάρτας Χρόνου',
    emplType: 'Τύπος Απασχόλησης',
    timetable: 'Ωράριο',
    yearsOfServGroup: 'Ομάδα Ετών Υπηρεσίας',
    dateOfAppointment: 'Ημερομηνία Διορισμού',
    primary: 'Κύριο',
    allocation: 'Κατανομή %',
    emplDeptsTitle: 'Τμήματα',
    salaryEligibilityTitle: 'Δικαίωμα 13ου Μισθού',
    servLine: 'Γραμμή Υπηρεσίας',
    function: 'Λειτουργία',

    reconciliationBalancesTitle: 'Συμφωνία Υπολοίπων Αδειών',
    reconcileBalances: 'Συμφωνία Υπολοίπων',
    reconciliationMess: 'Γίνεται Συμφωνία...',
    reconciliationSuccMess: 'Η Συμφωνία Ολοκληρώθηκε Επιτυχώς!',

    schedule: 'Πρόγραμμα',
    scheduleTitle: 'Πρόγραμμα',
    scheduleLoadingPreview: 'Δεν υπάρχουν Διαθέσιμα Δεδομένα\n\nΦαίνεται ότι δεν έχει προστεθεί Πρόγραμμα ακόμα. Παρακαλώ προσθέστε το Πρόγραμμά σας για να το δείτε εδώ.',
    emplDeptsLoadingPreview: 'Δεν υπάρχουν Διαθέσιμα Δεδομένα\n\nΦαίνεται ότι δεν έχουν προστεθεί Τμήματα ακόμα. Παρακαλώ προσθέστε τα Τμήματά σας για να τα δείτε εδώ.',
    provFundLoadingPreview: 'Δεν υπάρχουν Διαθέσιμα Δεδομένα\n\nΦαίνεται ότι δεν έχει προστεθεί Ταμείο Προνοίας ακόμα. Παρακαλώ προσθέστε τα Στοιχεία Ταμείου Προνοίας σας για να τα δείτε εδώ.',
    medicalSchemeLoadingPreview: 'Δεν υπάρχουν Διαθέσιμα Δεδομένα\n\nΦαίνεται ότι δεν έχει προστεθεί Ιατρικό Σχήμα ακόμα. Παρακαλώ προσθέστε τα Στοιχεία Ιατρικού Σχήματος για να τα δείτε εδώ.',

    leavebf: 'Άδειες Μεταφερόμενες',
    leavebfExpired: 'Άδειες Μεταφερόμενες Ληγμένες',
    allowance: 'Δικαίωμα',
    taken: 'Ληφθείσες',
    paidLost: 'Πληρώθηκαν/Χάθηκαν',
    accLeaveBalances: 'Συσσωρευμένα Υπόλοιπα Αδειών',
    recBalances: 'Συμφωνία Υπολοίπων Ως',
    startDateEmployment: 'Ημερομηνία Έναρξης Απασχόλησης',
    dateOfTermination: 'Ημερομηνία Λύσης Σύμβασης',
    dateOf13thSalaryEligibility: 'Ημερομηνία Δικαιώματος 13ου Μισθού',
    calcRevisedAllowance: 'Υπολογισμός Αναθεωρημένου Δικαιώματος',
    revisedAllowance: 'Αναθεωρημένο Δικαίωμα',
    activities: 'Δραστηριότητες',
    personalInterests: 'Προσωπικά Χόμπι & Ενδιαφέροντα',
    residencePermitNumber: 'Αριθμός Άδειας Παραμονής',
    residencePermitExpiry: 'Λήξη Άδειας Παραμονής',
    probPeriodinMonths: 'Δοκιμαστική Περίοδος σε Μήνες',
    dmPermnt: 'Ημερομηνία Μονιμοποίησης',
    doExpRetirmnt: 'Αναμενόμενη Ημερομηνία Συνταξιοδότησης',

    // MISCELLANEOUS Tab
    miscellaneousTitle: 'Διάφορα',
    memberOfUnion: 'Μέλος Συνδικάτου',
    union: 'Όνομα Συνδικάτου',
    memberOfProvFund: 'Μέλος Ταμείου Προνοίας',
    memberOfMedicalScheme: 'Μέλος Ιατρικού Σχήματος',
    provFund: 'Ταμείο Προνοίας',
    medScheme: 'Ιατρικό Σχήμα',
    carParkDetail: 'Στοιχεία Χώρου Στάθμευσης',
    parking: 'Στάθμευση',
    parkingLotNo: 'Αριθμός Θέσης Στάθμευσης',
    isCarParkCardHolder: 'Κάτοχος Κάρτας Χώρου Στάθμευσης',
    parksAtSpecifiedParking: 'Σταθμεύει Καθημερινά στον Ορισμένο Χώρο',
    vehRegNo: 'Αριθμός Κυκλοφορίας Οχήματος',
    medicalDetailsTitle: 'Ιατρικά Στοιχεία',
    medicalConditions: 'Ιατρικές Παθήσεις',
    bloodType: 'Ομάδα Αίματος',
    doctor: 'Γιατρός',
    unionsTitle: 'Συνδικάτα, Ιατρικό Σχήμα και Ταμείο Προνοίας',

    // Timesheets (My)
    MyTimesheets: 'Τα Δελτία μου Παρουσίας',
    nextTimesheet: 'Επόμενο Δελτίο Παρουσίας',
    period: 'Περίοδος',
    showSubmitted: 'Εμφάνιση Υποβληθέντων',
    showApproved: 'Εμφάνιση Εγκεκριμένων',
    TSfilters: 'Φίλτρα',
    waitingApproval: 'Αναμένει Έγκριση',
    timesheetDetails: 'Λεπτομέρειες Δελτίου Παρουσίας',
    TSchargable: 'Χρεώσιμος Χρόνος',
    TSnonchargable: 'Μη Χρεώσιμος Χρόνος',
    TSOutOfPocket: 'Τα Έξοδά μου',
    TSinfo: 'Πληροφορίες Δελτίου Παρουσίας',
    noLinesToShow: 'Δεν υπάρχουν γραμμές για εμφάνιση σε αυτό το Δελτίο Παρουσίας.',
    jobCode: 'Κωδικός Εργασίας',
    phaseCode: 'Κωδικός Φάσης',
    jobtitle: 'Τίτλος Εργασίας',
    newTimesheet: 'Νέο Δελτίο Παρουσίας',

    // Trainings
    noTrainings: "Δεν υπάρχουν εκπαιδεύσεις αυτή τη στιγμή.",
    titleAsc: "Τίτλος Αύξουσα",
    titleDesc: "Τίτλος Φθίνουσα",
    dateAsc: "Ημερομηνία Αύξουσα",
    dateDesc: "Ημερομηνία Φθίνουσα",
    all: "Όλα",
    category: 'Κατηγορία',
    trainingLocation: 'Τοποθεσία Εκπαίδευσης',
    trainingProvider: 'Πάροχος Εκπαίδευσης',
    externalFacilitator: 'Εξωτερικός Εισηγητής',
    ldNeed: 'Ανάγκη Μάθησης και Ανάπτυξης',
    ldMethod: 'Μέθοδος Μάθησης και Ανάπτυξης',
    isCompleted: 'Ολοκληρώθηκε',
    days: 'Ημέρες',
    hrs: 'Ώρες',
    workhrs: 'Ώρες Εργασίας',
    fees: 'Τέλη',
    subsidy: 'Επιδότηση',
    othercosts: 'Άλλα Κόστη',
    costperempl: 'Μέσο Κόστος/Συμμετέχοντα',
    equalCost: 'Ίσο Κόστος/Συμμετέχοντα',
    isabroad: 'Εξωτερικό',
    isinternal: 'Εσωτερική Εκπαίδευση',
    iseLearning: 'e-Learning',
    userEditable: 'Επεξεργάσιμο από Χρήστη',
    subsidyApplies: 'Ισχύει Επιδότηση',
    subsidyProvider: 'Πάροχος Επιδότησης',
    applicationDate: 'Ημερομηνία Αίτησης',
    receivedDate: 'Ημερομηνία Παραλαβής',
    doCertExp: 'Ημερομηνία Λήξης',
    certExpNotify: 'Ειδοποίησέ με',
    comment: 'Σχόλιο',
    saveFailed: "Αποτυχία αποθήκευσης δεδομένων.",
    dateValidation: "Η Ημερομηνία Λήξης πρέπει να είναι μετά την Ημερομηνία Έναρξης.",
    titleReq: "Ο τίτλος είναι υποχρεωτικός.",
    startDateReq: "Η Ημερομηνία Έναρξης είναι υποχρεωτική.",
    endDateReq: "Η Ημερομηνία Λήξης είναι υποχρεωτική.",
    companyReq: "Η Εταιρεία είναι υποχρεωτική.",
    totalNumberOfParticipants: 'Συνολικός Αριθμός Συμμετεχόντων',
    participants: 'Συμμετέχοντες',
    isAccepted: 'Έχει Γίνει Αποδεκτό',
    isFacilitator: 'Είναι Εισηγητής',
    firstEvaluation: 'Πρώτη Αξιολόγηση',
    secondEvaluation: 'Δεύτερη Αξιολόγηση',
    cost: 'Κόστος',
    training: 'Εκπαίδευση',
    documentType: 'Τύπος Εγγράφου',
    fileName: 'Όνομα Αρχείου',
    deleteAllPartConfirmation: 'Είστε σίγουροι ότι θέλετε να διαγράψετε όλους τους συμμετέχοντες αυτής της εκπαίδευσης;',
    noFileAvailable: 'Δεν υπάρχει διαθέσιμο αρχείο για λήψη.',
    failedDownload: 'Αποτυχία προετοιμασίας αρχείου για λήψη.',
    dateTrnEmpty: 'Παρακαλώ επιλέξτε ημερομηνία.',
    typeEmpty: 'Παρακαλώ εισάγετε έγγραφο ή τύπο εγγράφου.',
    noParticipantsToDelete: 'Δεν υπάρχουν συμμετέχοντες για διαγραφή.',
    allParticipantsDeleted: 'Όλοι οι συμμετέχοντες διαγράφηκαν.',
    errorDeletingParticipants: 'Σφάλμα διαγραφής συμμετεχόντων.',
    copyPartSuccess: 'Αντιγραφή Συμμετεχόντων επιτυχής.',
    copyPartError: 'Παρουσιάστηκε σφάλμα κατά την αντιγραφή συμμετεχόντων.',
    printTrnSuccess: 'Η αναφορά εκπαίδευσης εκτυπώθηκε επιτυχώς.',
    noParticipantsToExport: 'Δεν υπάρχουν συμμετέχοντες για εξαγωγή.',
    exportSuccess: 'Η εξαγωγή συμμετεχόντων ήταν επιτυχής.',

    // Modules
    duration: 'Διάρκεια (ώρες)',
    participantsLeft: 'Υπόλοιπες Θέσεις',
    attendees: 'Παρευρισκόμενοι',
    facilitator: 'Εισηγητές',
    employeeEmpty: 'Παρακαλώ επιλέξτε Υπάλληλο σε κάθε γραμμή',
    invalidDuration: 'Η διάρκεια δεν είναι έγκυρη.',
    codeEmpty: 'Παρακαλώ συμπληρώστε το πεδίο Κωδικός',
    NoDataPreview: 'Δεν υπάρχουν δεδομένα για προεπισκόπηση',
    trnEmpty: 'Δεν έχει επιλεγεί εκπαίδευση σε καμία γραμμή.',
    validationMssg: 'Μια εκπαίδευση έχει ήδη προαπαιτούμενα.',
    validationErr: 'Αποτυχία επικύρωσης προαπαιτούμενων.',
    dublicatedTRN: 'Έχετε συμπεριλάβει εκπαίδευση/εις περισσότερες από μία φορές.',

    // MyTrainings
    filterAccepted: 'Φίλτρο Αποδεκτών',
    dateOfCompletion: 'Ημερομηνία Ολοκλήρωσης',
    accepted: 'Αποδεκτό',
    pendingAcceptance: 'Αναμένει Αποδοχή',
    courseName: 'Όνομα Μαθήματος',
    newTraining: 'Νέα Εκπαίδευση',
    TRNDetails: 'Λεπτομέρειες Εκπαίδευσης',
    durationHrs: 'Διάρκεια (Ώρες)',
    acknowledgeCompletion: 'Επιβεβαίωση Ολοκλήρωσης',
    errorInsert: 'Παρουσιάστηκε σφάλμα κατά την εισαγωγή νέων δεδομένων.',
    confirmCompletion: 'Έχω διαβάσει και κατανοήσει το θέμα που παρουσιάστηκε. Αφού κάνετε κλικ στο κουμπί Αποδοχής, παρακαλώ υπογράψτε τη φόρμα συμμετοχής εκπαίδευσης (στο Τμήμα HR) και σημειώστε την ημερομηνία ολοκλήρωσης της εκπαίδευσης.',

    // Events
    event: 'Εκδήλωση',
    addOrg: 'Προσθήκη Διοργανωτή',
    restrictRegistration: 'Περιορισμός Εγγραφής',
    confirmParticipantsAutomatically: 'Αυτόματη Επιβεβαίωση Συμμετεχόντων',
    limitOnePersonPerParticipant: 'Περιορισμός Μίας Συνεδρίας ανά Συμμετέχοντα',
    createEvent: 'Δημιουργία Εκδήλωσης Εκπαίδευσης',
    deleteAllPartBeforeEvent: 'Η δημιουργία της εκδήλωσης θα διαγράψει όλους τους συμμετέχοντες. Οι συμμετέχοντες στην εκδήλωση πρέπει να προστεθούν μέσω συνεδρίας/ών. Είστε σίγουροι ότι θέλετε να συνεχίσετε;',
    cantAccessPartOnEventReason: 'Αυτή η εκπαίδευση έχει συσχετισμένη εκδήλωση. Οι συμμετέχοντες πρέπει να προστεθούν μέσω συνεδρίας/ών εκδήλωσης.',
    cantAccessPart: 'Δεν είναι δυνατή η προσθήκη συμμετεχόντων',
    errorSaving: 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση.',
    enterTitle: 'Εισάγετε τίτλο εκδήλωσης για να συνεχίσετε με την αποθήκευση.',
    enterDescription: 'Εισάγετε Περιγραφή για να συνεχίσετε με την αποθήκευση.',
    enterAtLeastOneOrganizer: 'Εισάγετε τουλάχιστον έναν διοργανωτή για να συνεχίσετε με την αποθήκευση.',
    cancelRegistretion: 'Ακύρωση Εγγραφής',
    session: 'Συνεδρία',
    register: 'Εγγραφή',
    registrationError: 'Παρουσιάστηκε σφάλμα κατά την εγγραφή σας σε αυτή την εκδήλωση.',
    registrationSuccess: 'Η εγγραφή σας ήταν επιτυχής.',
    cancelRegistrationError: 'Παρουσιάστηκε σφάλμα κατά την ακύρωση εγγραφής σας σε αυτή την εκδήλωση.',
    cancelRegistrationSuccess: 'Η ακύρωση εγγραφής σας ήταν επιτυχής.',
    noEvents: 'Δεν υπάρχουν διαθέσιμες εκδηλώσεις.',
    noRegistrations: 'Δεν είστε εγγεγραμμένοι σε καμία εκδήλωση.',

    // EMPLOYEE ADDITIONAL INFO Tab
    spouseInfo: 'Στοιχεία Συζύγου',
    spouseWorkingForDeloitte: 'Σύζυγος που Εργάζεται στη Deloitte',
    spouseName: 'Όνομα Συζύγου',
    spouseEmplID: 'ID Υπαλλήλου Συζύγου',
    spouseCompany: 'Εταιρεία Συζύγου',
    spouseServLine: 'Γραμμή Υπηρεσίας Συζύγου',
    spouseDept: 'Τμήμα Συζύγου',
    spouseBranch: 'Υποκατάστημα Συζύγου',
    spouseLocation: 'Τοποθεσία Συζύγου',
    secondaryInfo: 'Δευτερεύουσες Πληροφορίες',
    secondaryCompany: 'Δευτερεύουσα Εταιρεία',
    secondaryLocation: 'Δευτερεύουσα Τοποθεσία',

    // Medical Scheme
    insuredPerson: 'Ασφαλισμένος',
    insuranceCo: 'Ασφαλιστική Εταιρεία',
    contributionOfEmployer: 'Εισφορά (€) Εργοδότη',
    contributionOfEmployee: 'Εισφορά (€) Εργαζομένου',
    medicalSchemeTitle: 'Λεπτομέρειες Ιατρικού Σχήματος',

    // Provident Fund
    emplContribution: 'Εισφορά (%) Εργαζομένου',
    employerContribution: 'Εισφορά (%) Εργοδότη',
    provFundTitle: 'Λεπτομέρειες Ταμείου Προνοίας',
    emplContrReqMess: 'Η Εισφορά Εργαζομένου είναι υποχρεωτική!',
    employerContrReqMess: 'Η Εισφορά Εργοδότη είναι υποχρεωτική!',
    provFundReqMess: 'Το Ταμείο Προνοίας είναι υποχρεωτικό!',
    endDateBeforeStartDate: 'Η Ημερομηνία Λήξης πρέπει να είναι μεταγενέστερη της Ημερομηνίας Έναρξης!',

    // Promotion History
    dateOfPromotion: 'Ημερομηνία Προαγωγής',
    reviewer: 'Αξιολογητής',
    promHistTitle: 'Λεπτομέρειες Ιστορικού Προαγωγών',
    dateOfPromotionReqMess: 'Η Ημερομηνία Προαγωγής είναι υποχρεωτική!',

    // Generic
    loading: 'Φόρτωση, παρακαλώ περιμένετε...',
    saving: 'Αποθήκευση...',
    state: 'Κατάσταση',
    number: 'Αριθμός',

    // Locations
    telNumber: 'Αριθμός Τηλεφώνου',
    faxNumber: 'Αριθμός Φαξ',
    officeAddress: 'Διεύθυνση Γραφείου',
    city: 'Πόλη',
    postCode: 'Ταχυδρομικός Κώδικας',
    province: 'Επαρχία',
    regionalCode: 'Περιφερειακός Κωδικός',
    locationsLoadingPreview: 'Δεν υπάρχουν Διαθέσιμα Δεδομένα\nΦαίνεται ότι δεν έχουν προστεθεί τοποθεσίες ακόμα. Παρακαλώ προσθέστε νέες τοποθεσίες για να τις δείτε εδώ.',
    locations: 'Τοποθεσίες',
    additionalInfo: 'Σχόλια',
    additionalInfos: 'Πρόσθετες Πληροφορίες',

    // Bad Request Messages
    multEmptyLines: 'Δεν επιτρέπονται πολλαπλές κενές γραμμές. Παρακαλώ προσθέστε τις κατάλληλες πληροφορίες στην υπάρχουσα κενή γραμμή και δοκιμάστε ξανά.',
    issueMessage: 'Παρουσιάστηκε πρόβλημα με τις ενημερώσεις, παρακαλώ δοκιμάστε αργότερα.',
    issueDeleteMessage: 'Παρουσιάστηκε πρόβλημα με τις διαγραφές, παρακαλώ δοκιμάστε αργότερα.',
    duplicateBranchesMessage: 'Φαίνεται ότι έχετε εισάγει τον ίδιο κωδικό Υποκαταστήματος σε πολλές γραμμές. Βεβαιωθείτε ότι κάθε γραμμή έχει μοναδικό κωδικό.',
    branchWithLocationDeleteMess: 'Υποκαταστήματα με Τοποθεσίες δεν μπορούν να Διαγραφούν. Παρακαλώ διαγράψτε πρώτα τις Τοποθεσίες.',
    mandatoryCodeNotGivenBranches: 'Δεν έχετε παράσχει τον Υποχρεωτικό κωδικό Υποκαταστήματος. Παρακαλώ παρέχετέ τον για να προχωρήσετε.',
    mandatoryCodeNotGivenLocations: 'Δεν έχετε παράσχει τον Υποχρεωτικό κωδικό Τοποθεσίας. Παρακαλώ παρέχετέ τον για να προχωρήσετε.',
    wrongDatesBranches: 'Βεβαιωθείτε ότι οι ημερομηνίες είναι διαδοχικές',
    activeScheme: 'Δεν υπάρχει ενεργό Σχήμα Μισθού, αφαιρέστε την Ημερομηνία Λήξης από το ενεργό Σχήμα',
    onePrimary: 'Εντοπίστηκαν πολλαπλά ανοικτά σχήματα μισθού. Μόνο το τρέχον ενεργό σχήμα πρέπει να είναι ανοικτού τύπου',
    multiplePrimariesEmplDepts: 'Πρέπει να ορίσετε ακριβώς ΕΝΑ τμήμα ως κύριο!',
    sSchemeEmpty: 'Η ημερομηνία Σχήματος Μισθού δεν μπορεί να είναι κενή',
    duplicates: 'Δεν επιτρέπονται διπλές τιμές. Παρακαλώ διορθώστε τις επισημασμένες τιμές',
    noChanges: 'Η αποθήκευση ακυρώθηκε, δεν υπάρχουν αλλαγές.',
    leaveCodeandDesc: 'Η αποθήκευση ακυρώθηκε, όλοι οι Κωδικοί Άδειας και Περιγραφές Άδειας πρέπει να είναι μοναδικοί',
    deleteSchedulePeriodConfirmation: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την περίοδο προγραμματισμού;',
    deleteShiftAssignmentConfirmation: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την ανάθεση βάρδιας;',
    unsavedRosterChangesTitle: 'Μη αποθηκευμένες αλλαγές',
    unsavedRosterChangesMessage: 'Έχετε μη αποθηκευμένες αλλαγές στο πρόγραμμα βαρδιών. Αν συνεχίσετε χωρίς αποθήκευση, η πρόοδός σας θα χαθεί. Είστε βέβαιοι;',
    discardChanges: 'Απόρριψη αλλαγών',
    deleteFailed: 'Αποτυχία διαγραφής, παρακαλώ δοκιμάστε ξανά.',
    cannotDeleteAllEntries: 'Δεν είναι δυνατή η διαγραφή όλων των γραμμών, απαιτείται τουλάχιστον μία.',
    issueReload: 'Αποτυχία επαναφόρτωσης δεδομένων.',
    enterDate: 'Όλες οι γραμμές πρέπει να έχουν ημερομηνία.',
    mandatoryCodeNotGivenCategory: 'Δεν έχετε παράσχει τον Υποχρεωτικό κωδικό Κατηγορίας. Παρακαλώ παρέχετέ τον για να προχωρήσετε.',
    loadTrainingsError: 'Παρουσιάστηκε σφάλμα κατά τη φόρτωση δεδομένων.',

    // Success Messages
    insertLocationSuccMess: 'Η νέα τοποθεσία σας προστέθηκε επιτυχώς στο σύστημα!',
    updateLocationSuccMess: 'Τα στοιχεία τοποθεσίας ενημερώθηκαν επιτυχώς!',
    deleteLocationSuccMess: 'Η τοποθεσία διαγράφηκε επιτυχώς από το σύστημα.',
    allOperationsSuccMess: 'Όλες οι λειτουργίες ήταν επιτυχείς!',
    saveSuccess: 'Τα δεδομένα αποθηκεύτηκαν επιτυχώς',
    submittedSuccess: 'Τα δεδομένα υποβλήθηκαν επιτυχώς',
    confirmMessage: 'Επιβεβαίωση',
    validationSuccess: 'Επιτυχής Επικύρωση',

    // Functions
    headOfFunction: 'Επικεφαλής Λειτουργίας',
    exceedInvAmount: 'Υπέρβαση Ποσού Τιμολογίου',
    createNewFunction: 'Νέο',
    deleteFunction: 'Διαγραφή',
    saveFunction: 'Αποθήκευση',
    changeFunctionMessage: 'Έχετε αναποθήκευτες αλλαγές.\n Αν αλλάξετε Λειτουργίες τώρα, οι αλλαγές σας θα χαθούν.\n Παρακαλώ αποθηκεύστε τις αλλαγές σας πριν συνεχίσετε.',
    functionsNoDataPreview: 'Δεν υπάρχουν Διαθέσιμα Δεδομένα\nΦαίνεται ότι δεν έχουν προστεθεί Λειτουργίες ακόμα. Παρακαλώ προσθέστε νέες λειτουργίες για να τις δείτε εδώ.',
    functions: 'Λειτουργίες',
    functionCode: 'Διεπαφή',
    functionDescription: 'Περιγραφή Διεπαφής',
    chargesCode: 'Κωδικός Υπηρεσίας Διοικητικών Χρεώσεων',

    // WORKFLOWS
    saveSuccessMessage: 'Η Ροή Εργασίας αποθηκεύτηκε επιτυχώς',
    deleteSuccessMessage: 'Οι Ροές Εργασίας διαγράφηκαν επιτυχώς',
    errorMessage: 'Σφάλμα αποθήκευσης Ροών Εργασίας υπαλλήλου',

    // Academic Qualifications
    dos: 'Ημερομηνία Έναρξης',
    doa: 'Ημερομηνία Απόκτησης',
    institution: 'Ίδρυμα',
    institutionEmpty: 'Παρακαλώ επιλέξτε Ίδρυμα για όλα τα Ακαδημαϊκά Προσόντα.',
    titleAwareded: 'Τίτλος Απόκτησης',
    titleAwarededEmpty: 'Παρακαλώ επιλέξτε Τίτλο Απόκτησης για όλα τα Ακαδημαϊκά Προσόντα.',
    fos: 'Πεδίο Σπουδών',
    res: 'Αποτέλεσμα',
    resEmpty: 'Παρακαλώ επιλέξτε Αποτελέσματα για όλα τα Ακαδημαϊκά Προσόντα.',
    grade: 'Βαθμός',
    nooy: 'Αρ. Ετών',
    type: 'Τύπος',
    statusEmpty: 'Παρακαλώ επιλέξτε Κατάσταση για όλα τα Ακαδημαϊκά Προσόντα.',
    Comments: 'Σχόλια',
    errorSave: 'Αποτυχία αποθήκευσης. Παρακαλώ ελέγξτε τις τιμές σας και δοκιμάστε ξανά. Εάν το σφάλμα επιμένει, επικοινωνήστε με τον διαχειριστή σας.',
    academicQualSuccessSave: 'Η αποθήκευση ήταν επιτυχής',
    AcadNoReviewDataPreview: "Δεν υπάρχουν Διαθέσιμα Δεδομένα\nΦαίνεται ότι δεν έχουν προστεθεί Ακαδημαϊκά Προσόντα ακόμα. Παρακαλώ προσθέστε νέο Προσόν για να το δείτε εδώ.",
    errorReject: 'Αποτυχία απόρριψης. Παρουσιάστηκε σφάλμα κατά την απόρριψη του δελτίου παρουσίας. Δοκιμάστε αργότερα',

    // Additional Qualifications
    qualification: 'Προσόν',
    level: 'Επίπεδο',
    subEmpty: 'Το Αντικείμενο είναι υποχρεωτικό για όλα τα Πρόσθετα Προσόντα.',
    QualEmpty: 'Παρακαλώ εισάγετε το Προσόν για όλα τα Πρόσθετα Προσόντα.',
    statEmpty: 'Παρακαλώ επιλέξτε Κατάσταση για όλα τα Πρόσθετα Προσόντα.',
    doc: 'Έγγραφο',

    // Special Documents
    docType: 'Τύπος Εγγράφου',
    issueDate: 'Ημερομηνία Έκδοσης',
    expiryDate: 'Ημερομηνία Λήξης',
    isRenewed: 'Ανανεώθηκε',
    notifyMe: 'Ειδοποίησέ με',
    docStatus: 'Κατάσταση Εγγράφου',
    issuedBy: 'Εκδόθηκε Από',
    profession: 'Επάγγελμα Υπαλλήλου',
    professionOthLang: 'Επάγγελμα (Άλλη Γλώσσα)',
    Doc: 'Έγγραφο',
    docStatusEmpty: 'Παρακαλώ επιλέξτε Κατάσταση για όλα τα Ειδικά Έγγραφα.',
    issuedByEmpty: 'Παρακαλώ εισάγετε Εκδόθηκε Από για όλα τα Ειδικά Έγγραφα.',
    changesCancelled: 'Οι αλλαγές ακυρώθηκαν.',
    changesSavedSuccessfully: 'Οι αλλαγές αποθηκεύτηκαν επιτυχώς.',
    noSpecialDocsDataPreview: "Δεν υπάρχουν Διαθέσιμα Δεδομένα\nΦαίνεται ότι δεν έχουν προστεθεί Ειδικά Έγγραφα ακόμα. Παρακαλώ προσθέστε Ειδικά Έγγραφα για να τα δείτε εδώ.",
    noAttachment: "Χωρίς Συνημμένο",

    // Exit Process
    exitProcess: 'Διαδικασία Αποχώρησης',
    reason: 'Λόγος Αποχώρησης',
    newEmpl: 'Νέα Απασχόληση',
    interviewer: 'Συνεντευκτής',
    resignationDate: 'Ημερομηνία Παραίτησης',
    voluntary: 'Εκούσια',
    exitdate: 'Ημερομηνία',
    noExitProcessDataPreview: "Δεν υπάρχουν Διαθέσιμα Δεδομένα\nΦαίνεται ότι δεν έχουν πραγματοποιηθεί Διαδικασίες Αποχώρησης ακόμα.",
    reasonEmpty: 'Παρακαλώ εισάγετε Λόγο Αποχώρησης.',
    interviewerEmpty: 'Παρακαλώ εισάγετε Συνεντευκτή.',
    dateEmpty: 'Παρακαλώ επιλέξτε ημερομηνία αποχώρησης και παραίτησης.',

    // Service Lines
    hos: 'Επικεφαλής Γραμμής Υπηρεσίας',
    servCode: 'Κωδικός Υπηρεσίας',
    changeServiceLineMessage: 'Έχετε αναποθήκευτες αλλαγές.\n Αν αλλάξετε Γραμμές Υπηρεσίας τώρα, οι αλλαγές σας θα χαθούν.\n Παρακαλώ αποθηκεύστε τις αλλαγές σας πριν συνεχίσετε.',
    servLinesNoDataPreview: 'Δεν υπάρχουν Διαθέσιμα Δεδομένα\nΦαίνεται ότι δεν έχουν προστεθεί Γραμμές Υπηρεσίας ακόμα. Παρακαλώ προσθέστε νέες γραμμές υπηρεσίας για να τις δείτε εδώ.',
    serviceLines: 'Γραμμές Υπηρεσίας',

    // Departments
    hod: 'Επικεφαλής Τμήματος',
    deptCalendarFilter: 'Φιλτράρισμα Ημερολογίου ανά Τμήμα',
    interface: 'Διεπαφή',
    interfaceDesc: 'Περιγραφή Διεπαφής',
    adminChargesServices: 'Υπηρεσίες Διοικητικών Χρεώσεων',
    d365FDCode: 'Κωδικός D365 FD',
    deptsNoDataPreview: 'Δεν υπάρχουν Διαθέσιμα Δεδομένα\nΦαίνεται ότι δεν έχουν προστεθεί Τμήματα ακόμα. Παρακαλώ προσθέστε νέα τμήματα για να τα δείτε εδώ.',
    departments: 'Τμήματα',

    L4: 'L4',
    from: 'Από',
    to: 'Έως',
    day: 'Ημέρα',

    duplicateDepartmentsMessage: 'Φαίνεται ότι έχετε εισάγει τον ίδιο κωδικό Τμήματος σε πολλές γραμμές. Βεβαιωθείτε ότι κάθε γραμμή έχει μοναδικό κωδικό.',
    duplicateServiceLinesMessage: 'Φαίνεται ότι έχετε εισάγει τον ίδιο κωδικό Υπηρεσίας σε πολλές γραμμές. Βεβαιωθείτε ότι κάθε γραμμή έχει μοναδικό κωδικό.',
    duplicateFunctionsMessage: 'Φαίνεται ότι έχετε εισάγει τον ίδιο κωδικό Λειτουργίας σε πολλές γραμμές. Βεβαιωθείτε ότι κάθε γραμμή έχει μοναδικό κωδικό.',
    functionWithServLinesDeleteMess: 'Λειτουργίες με Γραμμές Υπηρεσίας δεν μπορούν να Διαγραφούν. Παρακαλώ διαγράψτε πρώτα τις Γραμμές Υπηρεσίας.',
    servLinesWithDeptsDeleteMess: 'Γραμμές Υπηρεσίας με Τμήματα δεν μπορούν να Διαγραφούν. Παρακαλώ διαγράψτε πρώτα τις Γραμμές Τμημάτων.',
    primaryKeyViolation: 'Υπάρχουν περισσότερες από μία εγγραφές με το ίδιο κλειδί. Οι εγγραφές πρέπει να είναι μοναδικές. Οι αλλαγές σας δεν θα αποθηκευτούν!',
    mandatoryCodeNotGivenFunctions: 'Δεν έχετε παράσχει τον Υποχρεωτικό κωδικό Λειτουργίας. Παρακαλώ παρέχετέ τον για να προχωρήσετε.',
    mandatoryCodeNotGivenServLines: 'Δεν έχετε παράσχει τον Υποχρεωτικό κωδικό Γραμμής Υπηρεσίας. Παρακαλώ παρέχετέ τον για να προχωρήσετε.',
    mandatoryCodeNotGivenDepartments: 'Δεν έχετε παράσχει τον Υποχρεωτικό κωδικό Τμήματος. Παρακαλώ παρέχετέ τον για να προχωρήσετε.',
    deptsIsUsedByEMPLDEPTS: 'Ορισμένα από τα τμήματα που προσπαθείτε να διαγράψετε είναι αναθεμένα σε υπαλλήλους και δεν μπορούν να διαγραφούν.',

    // Employee Wizard
    emplWizard: 'Οδηγός Υπαλλήλου',

    // Months
    jan: "Ιανουάριος",
    feb: "Φεβρουάριος",
    mar: "Μάρτιος",
    apr: "Απρίλιος",
    may: "Μάιος",
    jun: "Ιούνιος",
    jul: "Ιούλιος",
    aug: "Αύγουστος",
    sep: "Σεπτέμβριος",
    oct: "Οκτώβριος",
    nov: "Νοέμβριος",
    dec: "Δεκέμβριος",

    // Short Months
    m5: "Ιαν",
    m6: "Φεβ",
    m7: "Μαρ",
    m8: "Απρ",
    m9: "Μαϊ",
    m10: "Ιουν",
    m11: "Ιουλ",
    m12: "Αυγ",
    m1: "Σεπ",
    m2: "Οκτ",
    m3: "Νοε",
    m4: "Δεκ",

    // General
    asterisk: "*",

    // User Roles
    userRole: 'Ρόλος Χρήστη',
    encyptedPassword: 'Κρυπτογραφημένος Κωδικός',
    reqRestPassOnLogin: 'Απαιτείται επαναφορά κωδικού κατά την επόμενη σύνδεση',
    lock: 'Κλείδωμα',
    loadingUserRoles: 'Φόρτωση Ρόλων Χρήστη...',
    emplUserRoleSavedSuccMess: 'Ο Ρόλος Χρήστη αποθηκεύτηκε επιτυχώς!',
    emplUserRoleErr: 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση των ενημερώσεων. Παρακαλώ δοκιμάστε αργότερα.',
    issuePassword: 'Έκδοση Κωδικού',
    issuedPassSucc: 'Ο Κωδικός Εκδόθηκε Επιτυχώς!',
    issuedPassErr: 'Η έκδοση κωδικού απέτυχε. Παρακαλώ δοκιμάστε ξανά και αν το πρόβλημα επιμένει, επικοινωνήστε με τον διαχειριστή συστήματος.',
    sendUsername: 'Αποστολή Ονόματος Χρήστη',
    emailSendShortly: 'Το email θα αποσταλεί σύντομα.',
    noEmailMessNotSendUsername: 'Ο υπάλληλος δεν έχει email ακόμα. Παρακαλώ επαναστείλετε το όνομα χρήστη μόλις συμπληρωθεί το email του υπαλλήλου.',
    noEmailMessNotSendPassword: 'Ο υπάλληλος δεν έχει email ακόμα. Παρακαλώ επαναστείλετε τον κωδικό μόλις συμπληρωθεί το email του υπαλλήλου.',
    emailNotSendErr: 'Η αποστολή email απέτυχε. Παρακαλώ δοκιμάστε ξανά και αν το πρόβλημα επιμένει, επικοινωνήστε με τον διαχειριστή συστήματος.',
    errorUpdating: 'Παρουσιάστηκε σφάλμα κατά την ενημέρωση της βάσης δεδομένων. Παρακαλώ επικοινωνήστε με τον διαχειριστή συστήματος.',

    // Employee Authorizations
    addRule: 'Προσθήκη Κανόνα',
    includeInactive: 'Συμπερίληψη Ανενεργών Υπαλλήλων',
    includedEmpls: 'Συμπεριλαμβανόμενοι Υπάλληλοι',
    includeSpecEmpls: 'Συμπερίληψη Συγκεκριμένων Υπαλλήλων',
    summary: 'Σύνοψη',
    emplsSelectedThroughCriteria: 'Υπάλληλοι Επιλεγμένοι μέσω Κριτηρίων',
    employeesExcluded: 'Αποκλεισμός Συγκεκριμένων Υπαλλήλων',
    specificEmplsAdded: 'Συγκεκριμένοι Υπάλληλοι Προστέθηκαν',
    totalNumOfEmplsIncluded: 'Συνολικός Αριθμός Συμπεριλαμβανόμενων Υπαλλήλων',
    addSpecificEmpls: 'Προσθήκη Συγκεκριμένων Υπαλλήλων',
    activeStatus: 'Ενεργή Κατάσταση',
    missingFields: 'Λείπουν Πεδία...',
    missingFieldsSubMessage: 'Για να επιλέξετε συγκεκριμένους υπαλλήλους, βεβαιωθείτε ότι το πεδίο εταιρείας είναι συμπληρωμένο.',
    addChosenEmpls: 'Προσθήκη Επιλεγμένων Υπαλλήλων',
    emplsSucc: 'Οι Υπάλληλοι Προστέθηκαν Επιτυχώς',
    onAddSpecificCancelTitle: 'Είστε σίγουροι;',
    onAddSpecificCancelMessage: 'Αν προχωρήσετε, όλοι οι τρέχοντες επιλεγμένοι υπάλληλοι θα αφαιρεθούν από τη λίστα σας.',
    emplAuthSuccMess: 'Οι εξουσιοδοτήσεις του υπαλλήλου προστέθηκαν επιτυχώς!',

    // Reports To
    manager: 'Διευθυντής',
    notifiedUponApproval: 'Ειδοποιείται κατά την Έγκριση',
    approvesLeaves: 'Εγκρίνει Άδειες',
    approvesTimesheets: 'Εγκρίνει Δελτία Παρουσίας',
    noDataAvailable: 'Δεν υπάρχουν Διαθέσιμα Δεδομένα',
    notValidReportsTo: 'Παρακαλώ επιλέξτε μόνο έναν αναφερόμενο ως κύριο, έναν για έγκριση αδειών και έναν για έγκριση δελτίων παρουσίας.',
    reportsToSuccMess: 'Η Αναφορά Προς ενημερώθηκε επιτυχώς!',
    loadManagersFailed: 'Αποτυχία φόρτωσης της λίστας διευθυντών',

    // Workflows
    workflow: 'Ροή Εργασίας',
    workflowCategory: 'Κατηγορία Ροής Εργασίας',

    // Leave Analysis
    leaveAnalysis: 'Ανάλυση Άδειας',
    createLeaveAnalysisMess: 'Θέλετε να δημιουργήσετε την ανάλυση άδειας του υπαλλήλου;',
    successLeaveaAnalysis: "Η ανάλυση άδειας δημιουργήθηκε με επιτυχία για το επόμενο οικονομικό έτος.",
    missingUser: "Λείπουν πληροφορίες χρήστη, εργαζομένου ή εταιρείας.",
    anErrorOccurred: "Παρουσιάστηκε σφάλμα κατά τη δημιουργία της ανάλυσης άδειας.",
    failedTo: "Δεν είναι δυνατή η δημιουργία ανάλυσης άδειας για το επόμενο οικονομικό έτος.",
    createLA: 'Δημιουργία Ανάλυσης Αδειών',
    enterYear: 'Εισαγάγετε το οικονομικό έτος που θέλετε να δημιουργήσετε',

    // Advanced Settings
    changeEmplId: 'Αλλαγή ID Υπαλλήλου',
    advSettings: 'Ρυθμίσεις για Προχωρημένους',

    // Company Authorizations
    removeAll: "Αφαίρεση όλων",
    authorisedUsers: "Εξουσιοδοτημένοι χρήστες",
    noAuthorisedUsers: "Δεν υπάρχουν εξουσιοδοτημένοι χρήστες",
    availableUsers: "Διαθέσιμοι χρήστες",
    noAvailableUsers: "Δεν υπάρχουν διαθέσιμοι χρήστες",
    authSuccessSave: "Οι εξουσιοδοτήσεις αποθηκεύτηκαν με επιτυχία",
    failedSave: "Αποτυχία αποθήκευσης εξουσιοδοτήσεων",
    //Alerts 
    emplAlerts: 'Ειδοποιήσεις Υπαλλήλου',
    standardAlerts: 'Τυπικές ειδοποιήσεις',
    customAlerts: 'Προσαρμοσμένες ειδοποιήσεις',
    completeExistingAlerts: 'Συμπληρώστε την υπάρχουσα ειδοποίηση',
    selectMonitorFirst: 'Παρακαλώ επιλέξτε παρακολούθηση πριν προσθέσετε νέα ειδοποίηση',
    saveSuccess: 'Οι αλλαγές αποθηκεύτηκαν με επιτυχία',
    saveError: 'Η αποθήκευση απέτυχε. Παρακαλώ δοκιμάστε ξανά.',
    noChanges: 'Δεν υπάρχουν αλλαγές για αποθήκευση',
    saving: 'Αποθήκευση...',
    versionMismatch: "Χρησιμοποιείτε μια παλαιότερη έκδοση, παρακαλώ επικοινωνήστε με τον διαχειριστή σας.",
    versionMismatchTitle: "Ασυμβατότητα έκδοσης",
    versionCheckFailedTitle: "Αποτυχία ελέγχου έκδοσης",
    versionCheckFailed: "Δεν ήταν δυνατή η επαλήθευση της έκδοσης της εφαρμογής σας. Παρακαλώ δοκιμάστε ξανά αργότερα.",


     //Professional Bodies
    pro: "Επαγγελματικός Φορέας",
    memtype: "Τύπος Μέλους",
    memdate: "Ημερομηνία Εγγραφής/Ιδιότητας Μέλους",
    examdate: "Ημερομηνία Τελευταίας Επιτυχούς Εξέτασης",
    reginumber: "Αριθμός Μητρώου/Εγγραφής",
    expdate: "Ημερομηνία Λήξης Ιδιότητας Μέλους",
    profBodiesSuccessSave: "Οι επαγγελματικοί φορείς διασώθηκαν με επιτυχία",
    proEmpty: "Το Επαγγελματικό Σώμα δεν μπορεί να είναι κενό",
    memtypeEmpty: "Ο Τύπος Μέλους δεν μπορεί να είναι κενός"


};